/*! uforiq-schedule v1.0.0 | delivery scheduling widget | generated from src/ by scripts/build.js, do not edit */
(function () {
  'use strict';
  if (window.UforiqSchedule && window.UforiqSchedule.version) return;
  var module = { exports: {} };
  // ---- src/engine.js ----
  /*
   * uforiq-schedule engine
   * Pure scheduling logic shared by the storefront widget and the tests.
   * No DOM, no network, no globals beyond Intl. ES2017.
   *
   * Works as a CommonJS module (Node tests) and as a plain script
   * (exposes window.UforiqScheduleEngine). scripts/build.js inlines it into
   * theme/assets/uforiq-schedule.js.
   */
  (function (root, factory) {
    'use strict';
    var api = factory();
    if (typeof module === 'object' && module && module.exports) module.exports = api;
    else if (root) root.UforiqScheduleEngine = api;
  })(typeof window !== 'undefined' ? window : this, function () {
    'use strict';

    var DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var DEFAULT_TZ = 'America/Chicago';
    var EARTH_RADIUS_MI = 3958.7613;

    var ATTR = {
      method: 'Checkout-Method',
      locationId: 'Delivery-Location-Id',
      date: 'Delivery-Date',
      time: 'Delivery-Time',
      slotId: 'Delivery-Slot-Id',
      note: 'Delivery-Note',
      priority: 'Delivery-Priority',
      pin: 'Delivery-Pin',         // Google Maps link to the shopper's door pin (optional)
      saveNote: '_uq_save_note',   // "0" = do not save the note to the customer account (ops app reads it)
      noShip: 'No-Ship-Items',     // "yes" while the cart holds a no-ship item (Shipy hides shipping rates on it)
      area: 'Delivery-Area' // owned by the site; read only, never written
    };
    // Keys this widget owns, in write order. Delivery-Area is deliberately absent.
    var OWNED_KEYS = [ATTR.method, ATTR.locationId, ATTR.date, ATTR.time, ATTR.slotId, ATTR.note, ATTR.priority, ATTR.pin, ATTR.saveNote, ATTR.noShip];
    var NOTE_MAX = 250;
    var PIN_URL = 'https://www.google.com/maps/search/?api=1&query=';

    function assign(target) {
      for (var i = 1; i < arguments.length; i++) {
        var src = arguments[i];
        if (!src) continue;
        for (var k in src) if (Object.prototype.hasOwnProperty.call(src, k)) target[k] = src[k];
      }
      return target;
    }

    function pad2(n) { return (n < 10 ? '0' : '') + n; }

    /* ------------------------------------------------------------------ time */

    var dtfCache = {};
    function dtf(tz) {
      if (!dtfCache[tz]) {
        dtfCache[tz] = new Intl.DateTimeFormat('en-US', {
          timeZone: tz,
          hourCycle: 'h23',
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit'
        });
      }
      return dtfCache[tz];
    }

    /** Wall-clock parts of an instant in a time zone. DST safe (Intl does the work). */
    function zonedParts(ms, tz) {
      var parts = dtf(tz || DEFAULT_TZ).formatToParts(new Date(ms));
      var o = {};
      for (var i = 0; i < parts.length; i++) o[parts[i].type] = parts[i].value;
      var hour = Number(o.hour) % 24; // some engines print 24 for midnight
      var p = {
        year: Number(o.year), month: Number(o.month), day: Number(o.day),
        hour: hour, minute: Number(o.minute), second: Number(o.second)
      };
      p.dateKey = p.year + '-' + pad2(p.month) + '-' + pad2(p.day);
      p.weekday = weekdayOf(p.dateKey);
      p.minutes = p.hour * 60 + p.minute;
      return p;
    }

    function tzOffsetMs(ms, tz) {
      var p = zonedParts(ms, tz);
      var asUtc = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
      return asUtc - (ms - (((ms % 1000) + 1000) % 1000));
    }

    /** Instant (epoch ms) of a wall-clock time "HH:MM" on dateKey "YYYY-MM-DD" in tz. */
    function zonedTimeToInstant(dateKey, hhmm, tz) {
      var d = parseDateKey(dateKey);
      var t = parseHHMM(hhmm);
      var guess = Date.UTC(d.y, d.m - 1, d.d, Math.floor(t / 60), t % 60, 0);
      var off1 = tzOffsetMs(guess, tz);
      var ms = guess - off1;
      var off2 = tzOffsetMs(ms, tz);
      if (off2 !== off1) ms = guess - off2;
      return ms;
    }

    function parseDateKey(key) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(key));
      if (!m) throw new Error('Bad date key: ' + key);
      return { y: Number(m[1]), m: Number(m[2]), d: Number(m[3]) };
    }

    function parseHHMM(s) {
      var m = /^(\d{1,2}):(\d{2})$/.exec(String(s).trim());
      if (!m) throw new Error('Bad time: ' + s);
      return Number(m[1]) * 60 + Number(m[2]);
    }

    function addDays(dateKey, n) {
      var d = parseDateKey(dateKey);
      var t = new Date(Date.UTC(d.y, d.m - 1, d.d + n));
      return t.getUTCFullYear() + '-' + pad2(t.getUTCMonth() + 1) + '-' + pad2(t.getUTCDate());
    }

    function weekdayOf(dateKey) {
      var d = parseDateKey(dateKey);
      return new Date(Date.UTC(d.y, d.m - 1, d.d)).getUTCDay();
    }

    /** "18:00" -> "6:00 PM" */
    function formatTime12(hhmm) {
      var t = parseHHMM(hhmm);
      var h = Math.floor(t / 60);
      var m = t % 60;
      var suffix = h >= 12 && h < 24 ? 'PM' : 'AM';
      var h12 = h % 12 === 0 ? 12 : h % 12;
      return h12 + ':' + pad2(m) + ' ' + suffix;
    }

    function slotLabel(start, end) { return formatTime12(start) + ' - ' + formatTime12(end); }

    function shortDate(dateKey) {
      var d = parseDateKey(dateKey);
      return MONTH_SHORT[d.m - 1] + ' ' + d.d;
    }

    /* ------------------------------------------------------------------- geo */

    function toRad(x) { return x * Math.PI / 180; }

    /** Great-circle distance in miles. */
    function haversineMiles(a, b) {
      var dLat = toRad(b.lat - a.lat);
      var dLng = toRad(b.lng - a.lng);
      var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * EARTH_RADIUS_MI * Math.asin(Math.min(1, Math.sqrt(s)));
    }

    function normalizeZip(zip) {
      var m = /^\s*(\d{5})(?:-\d{4})?\s*$/.exec(String(zip == null ? '' : zip));
      return m ? m[1] : null;
    }

    /* ------------------------------------------------------- ZIP -> state */

    // First three ZIP digits -> USPS state code: [from, to, code], inclusive, ascending.
    // Covers the 50 states, DC, PR, VI, GU and the military codes AA/AE/AP. Unused
    // prefixes map to nothing (zipToState returns null and the shipping check is skipped).
    var ZIP3_STATES = [
      [5, 5, 'NY'], [6, 7, 'PR'], [8, 8, 'VI'], [9, 9, 'PR'], [10, 27, 'MA'], [28, 29, 'RI'],
      [30, 38, 'NH'], [39, 49, 'ME'], [50, 54, 'VT'], [55, 55, 'MA'], [56, 59, 'VT'], [60, 69, 'CT'],
      [70, 89, 'NJ'], [90, 99, 'AE'], [100, 149, 'NY'], [150, 196, 'PA'], [197, 199, 'DE'],
      [200, 200, 'DC'], [201, 201, 'VA'], [202, 205, 'DC'], [206, 219, 'MD'], [220, 246, 'VA'],
      [247, 268, 'WV'], [270, 289, 'NC'], [290, 299, 'SC'], [300, 319, 'GA'], [320, 339, 'FL'],
      [340, 340, 'AA'], [341, 349, 'FL'], [350, 369, 'AL'], [370, 385, 'TN'], [386, 397, 'MS'],
      [398, 399, 'GA'], [400, 427, 'KY'], [430, 459, 'OH'], [460, 479, 'IN'], [480, 499, 'MI'],
      [500, 528, 'IA'], [530, 549, 'WI'], [550, 567, 'MN'], [569, 569, 'DC'], [570, 577, 'SD'],
      [580, 588, 'ND'], [590, 599, 'MT'], [600, 629, 'IL'], [630, 658, 'MO'], [660, 679, 'KS'],
      [680, 693, 'NE'], [700, 714, 'LA'], [716, 729, 'AR'], [730, 732, 'OK'], [733, 733, 'TX'],
      [734, 749, 'OK'], [750, 799, 'TX'], [800, 816, 'CO'], [820, 831, 'WY'], [832, 838, 'ID'],
      [840, 847, 'UT'], [850, 865, 'AZ'], [870, 884, 'NM'], [885, 885, 'TX'], [889, 898, 'NV'],
      [900, 961, 'CA'], [962, 966, 'AP'], [967, 968, 'HI'], [969, 969, 'GU'], [970, 979, 'OR'],
      [980, 994, 'WA'], [995, 999, 'AK']
    ];
    var STATE_NAMES = {
      AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California', CO: 'Colorado',
      CT: 'Connecticut', DE: 'Delaware', DC: 'Washington, DC', FL: 'Florida', GA: 'Georgia', HI: 'Hawaii',
      ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana',
      ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi',
      MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey',
      NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma',
      OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota',
      TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia', WA: 'Washington',
      WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming', PR: 'Puerto Rico', VI: 'the U.S. Virgin Islands',
      GU: 'Guam', AA: 'military addresses (AA)', AE: 'military addresses (AE)', AP: 'military addresses (AP)'
    };

    /** "78705" -> { code: 'TX', name: 'Texas' }; null for a bad ZIP or an unused prefix. */
    function zipToState(zip) {
      var z = normalizeZip(zip);
      if (!z) return null;
      var p = Number(z.slice(0, 3));
      for (var i = 0; i < ZIP3_STATES.length; i++) {
        var r = ZIP3_STATES[i];
        if (p < r[0]) return null;
        if (p <= r[1]) return { code: r[2], name: STATE_NAMES[r[2]] };
      }
      return null;
    }

    /**
     * Cache key for one shipping check: cart token + ZIP + what is in the cart
     * (variant x quantity, plus the total, since rates can depend on the subtotal).
     */
    function shipCheckKey(cart, zip) {
      var items = ((cart && cart.items) || []).map(function (it) {
        return String(it.variant_id || it.id) + 'x' + (Number(it.quantity) || 0);
      }).sort();
      return [(cart && cart.token) || '', normalizeZip(zip) || '', items.join(','), Number(cart && cart.total_price) || 0].join('|');
    }

    /** A zone defined by an explicit ZIP list (zone.zips) instead of a distance ring. */
    function isZipZone(z) { return !!(z && z.zips && z.zips.length); }

    /** A metro's zones: distance rings first (smallest ring first), then ZIP-list zones in config order. */
    function zonesForMetro(config, metro) {
      var mine = config.zones.filter(function (z) { return z.metro === metro; });
      var rings = mine.filter(function (z) { return !isZipZone(z); })
        .sort(function (a, b) { return (a.maxMiles - b.maxMiles) || (a.minMiles - b.minMiles); });
      return rings.concat(mine.filter(isZipZone));
    }

    function ringZonesForMetro(config, metro) {
      return zonesForMetro(config, metro).filter(function (z) { return !isZipZone(z); });
    }

    /** The ZIP-list zone of `metro` that lists `zip` (any metro when `metro` is null), or null. */
    function zipZoneFor(config, zip, metro) {
      for (var i = 0; i < config.zones.length; i++) {
        var z = config.zones[i];
        if (isZipZone(z) && (!metro || z.metro === metro) && z.zips.indexOf(zip) >= 0) return z;
      }
      return null;
    }

    /**
     * Is `zip` on the config's exclusion list (config.excludeZips)? An excluded ZIP is outside
     * every delivery zone, rings and ZIP lists alike, in every metro: it gets Shipping.
     */
    function isExcludedZip(config, zip) {
      var z = normalizeZip(zip);
      var list = config && config.excludeZips;
      if (!z || !list || !list.length) return false;
      for (var i = 0; i < list.length; i++) if (normalizeZip(list[i]) === z) return true;
      return false;
    }

    /** Smallest ring containing `miles` (edges inclusive; the smaller ring wins a tie). */
    function matchRing(zones, miles) {
      for (var i = 0; i < zones.length; i++) {
        if (miles >= zones[i].minMiles && miles <= zones[i].maxMiles) return zones[i];
      }
      return null;
    }

    function metroIds(config) {
      var seen = {};
      var out = [];
      config.zones.forEach(function (z) { if (!seen[z.metro]) { seen[z.metro] = 1; out.push(z.metro); } });
      return out;
    }

    /**
     * Resolve a ZIP to a delivery zone.
     * zipTable: { "78705": [lat, lng], ... }  (or { zips: {...} })
     * Returns { status: 'ok'|'invalid'|'out_of_zone'|'other_metro', zip, zone, miles, metro, otherMetro }
     * A ZIP listed by a ZIP-list zone (zone.zips) resolves to that zone, ahead of the distance
     * rings, even when it is not in the centroid table (miles is then null).
     * A ZIP on config.excludeZips is out_of_zone (excluded: true) whatever the rings say.
     */
    function resolveZip(zip, config, zipTable, metro) {
      var z = normalizeZip(zip);
      if (!z) return { status: 'invalid', zip: String(zip || '') };
      if (isExcludedZip(config, z)) return { status: 'out_of_zone', zip: z, known: true, excluded: true };
      var table = zipTable && zipTable.zips ? zipTable.zips : (zipTable || {});
      var pt = table[z];
      var p = pt ? { lat: pt[0], lng: pt[1] } : null;
      var metros = metroIds(config);
      var hits = {};
      for (var i = 0; i < metros.length; i++) {
        var listed = zipZoneFor(config, z, metros[i]);
        if (listed) {
          hits[metros[i]] = { zone: listed, miles: p ? haversineMiles(p, listed.center) : null };
          continue;
        }
        var zones = ringZonesForMetro(config, metros[i]);
        if (!zones.length || !p) continue;
        var miles = haversineMiles(p, zones[0].center);
        var zone = matchRing(zones, miles);
        if (zone) hits[metros[i]] = { zone: zone, miles: miles };
      }
      if (!p && !Object.keys(hits).length) return { status: 'out_of_zone', zip: z, known: false };
      if (metro && hits[metro]) {
        return { status: 'ok', zip: z, zone: hits[metro].zone, miles: hits[metro].miles, metro: metro, known: true };
      }
      var others = Object.keys(hits);
      if (others.length) {
        return { status: 'other_metro', zip: z, otherMetro: others[0], miles: hits[others[0]].miles, known: true };
      }
      return { status: 'out_of_zone', zip: z, known: true };
    }

    /* -------------------------------------------------------------- door pin */

    function num(v) { return typeof v === 'function' ? Number(v()) : Number(v); }

    /** {lat, lng} from a plain object or a google.maps.LatLng, rounded to 6 decimals; null if invalid. */
    function toPoint(p) {
      if (!p) return null;
      var lat = num(p.lat);
      var lng = num(p.lng);
      if (!isFinite(lat) || !isFinite(lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
      return { lat: Math.round(lat * 1e6) / 1e6, lng: Math.round(lng * 1e6) / 1e6 };
    }

    /** Delivery-Pin value: a Google Maps search link with 6-decimal coordinates. */
    function pinUrl(p) {
      var pt = toPoint(p);
      return pt ? PIN_URL + pt.lat.toFixed(6) + ',' + pt.lng.toFixed(6) : '';
    }

    /** Reads a Delivery-Pin link back into {lat, lng} (null if it is not one of ours). */
    function parsePin(url) {
      var m = /[?&]query=(-?\d{1,3}(?:\.\d+)?),(-?\d{1,3}(?:\.\d+)?)(?:&|$)/.exec(String(url || ''));
      return m ? toPoint({ lat: m[1], lng: m[2] }) : null;
    }

    /** Map start point for a metro: the ring center of its zones. */
    function metroCenter(config, metro) {
      var zones = zonesForMetro(config, metro);
      return zones.length ? { lat: zones[0].center.lat, lng: zones[0].center.lng } : null;
    }

    /**
     * Is a door pin inside the metro's delivery area (any of its rings, up to
     * the ring's maxMiles from its center)? When the shopper's ZIP is in one of the
     * metro's ZIP-list zones, that zone's pin radius (pinMaxMiles) counts too.
     * Returns { ok, miles, maxMiles, reason: null | 'invalid' | 'no_metro' | 'too_far' }.
     */
    function checkPin(config, metro, p, zip) {
      var pt = toPoint(p);
      if (!pt) return { ok: false, reason: 'invalid' };
      var zones = ringZonesForMetro(config, metro);
      var nz = normalizeZip(zip);
      var listed = nz ? zipZoneFor(config, nz, metro) : null;
      if (listed) zones = zones.concat([listed]);
      if (!zones.length) return { ok: false, reason: 'no_metro' };
      var best = null;
      zones.forEach(function (z) {
        var miles = haversineMiles(pt, z.center);
        var inside = miles <= z.maxMiles;
        if (!best || (inside && !best.ok) || (inside === best.ok && miles < best.miles)) {
          best = { ok: inside, miles: miles, maxMiles: z.maxMiles };
        }
      });
      var max = Math.max.apply(null, zones.map(function (z) { return z.maxMiles; }));
      return { ok: best.ok, miles: best.miles, maxMiles: max, reason: best.ok ? null : 'too_far' };
    }

    /* -------------------------------------------------------------- schedule */

    function perWeekday(map, weekday) {
      if (map == null) return null;
      if (typeof map === 'string' || Array.isArray(map)) return map;
      var key = DAY_KEYS[weekday];
      if (Object.prototype.hasOwnProperty.call(map, key)) return map[key];
      if (Object.prototype.hasOwnProperty.call(map, 'default')) return map['default'];
      return null;
    }

    function slotsForWeekday(zone, weekday) {
      var s = perWeekday(zone.slots, weekday);
      return Array.isArray(s) ? s : [];
    }

    function cutoffForWeekday(zone, weekday) {
      var c = perWeekday(zone.sameDayCutoff, weekday);
      return typeof c === 'string' && c ? c : null;
    }

    function isBlackout(config, zone, dateKey) {
      var lists = [config.blackoutDates || [], (zone && zone.blackoutDates) || []];
      for (var i = 0; i < lists.length; i++) {
        for (var j = 0; j < lists[i].length; j++) {
          if (String(lists[i][j]).replace(/\//g, '-') === dateKey) return true;
        }
      }
      return false;
    }

    function slotIdFor(zoneId, dateKey, start) {
      return zoneId + '-' + dateKey.replace(/-/g, '') + '-' + start.replace(':', '');
    }

    function parseSlotId(id) {
      var m = /^(.+)-(\d{4})(\d{2})(\d{2})-(\d{2})(\d{2})$/.exec(String(id || ''));
      if (!m) return null;
      return { zoneId: m[1], dateKey: m[2] + '-' + m[3] + '-' + m[4], start: m[5] + ':' + m[6] };
    }

    /**
     * Can this slot still be booked at nowMs?
     * Rule: now + prepMinutes <= slot start (or end, per bookUntil), and on the
     * same day, now < sameDayCutoff. Comparisons are on real instants, so DST
     * changes cannot shift a cutoff by an hour.
     */
    function slotBookability(zone, dateKey, slot, nowMs, tz, todayKey) {
      var boundary = zone.bookUntil === 'end' ? slot.end : slot.start;
      var boundaryMs = zonedTimeToInstant(dateKey, boundary, tz);
      if (nowMs + (zone.prepMinutes || 0) * 60000 > boundaryMs) return { ok: false, reason: 'prep' };
      if (dateKey === todayKey) {
        var cutoff = cutoffForWeekday(zone, weekdayOf(dateKey));
        if (cutoff && nowMs >= zonedTimeToInstant(dateKey, cutoff, tz)) return { ok: false, reason: 'cutoff' };
      }
      return { ok: true, reason: null };
    }

    /**
     * The booking window for a zone: `daysAhead` calendar days including today.
     * Each day lists every configured slot with availability.
     */
    function buildDays(config, zone, nowMs) {
      var tz = config.timezone || DEFAULT_TZ;
      var today = zonedParts(nowMs, tz).dateKey;
      var n = Math.max(1, Math.floor(zone.daysAhead || 1));
      var days = [];
      for (var i = 0; i < n; i++) {
        var key = addDays(today, i);
        var wd = weekdayOf(key);
        var blackout = isBlackout(config, zone, key);
        var defs = slotsForWeekday(zone, wd);
        var slots = defs.map(function (def) {
          var b = blackout ? { ok: false, reason: 'blackout' } : slotBookability(zone, key, def, nowMs, tz, today);
          return {
            id: slotIdFor(zone.id, key, def.start),
            zoneId: zone.id,
            dateKey: key,
            start: def.start,
            end: def.end,
            label: def.label || slotLabel(def.start, def.end),
            startMs: zonedTimeToInstant(key, def.start, tz),
            available: b.ok,
            reason: b.reason
          };
        });
        var anyOpen = slots.some(function (s) { return s.available; });
        days.push({
          dateKey: key,
          ymd: key.replace(/-/g, '/'),
          weekday: wd,
          offset: i,
          label: i === 0 ? 'Today' : (i === 1 ? 'Tomorrow' : DAY_NAMES[wd]),
          shortDate: shortDate(key),
          slots: slots,
          available: anyOpen,
          reason: anyOpen ? null : (blackout ? 'blackout' : (defs.length ? 'full' : 'closed'))
        });
      }
      return days;
    }

    function allSlots(days) {
      var out = [];
      days.forEach(function (d) { out = out.concat(d.slots); });
      return out;
    }

    function earliestSlot(days) {
      var s = allSlots(days).filter(function (x) { return x.available; });
      s.sort(function (a, b) { return a.startMs - b.startMs; });
      return s[0] || null;
    }

    function findSlot(days, id) {
      var s = allSlots(days);
      for (var i = 0; i < s.length; i++) if (s[i].id === id) return s[i];
      return null;
    }

    /** First available slot starting at or after `afterMs`, else the earliest one. */
    function nextAvailableSlot(days, afterMs) {
      var s = allSlots(days).filter(function (x) { return x.available; });
      s.sort(function (a, b) { return a.startMs - b.startMs; });
      for (var i = 0; i < s.length; i++) if (s[i].startMs >= afterMs) return s[i];
      return s[0] || null;
    }

    /* ----------------------------------------------------------------- money */

    function toCents(amount) { return Math.round(Number(amount || 0) * 100); }

    /** 599 -> "$5.99"; whole dollars can drop the cents with {trim:true}: 10000 -> "$100" */
    function formatMoney(cents, opts) {
      var neg = cents < 0;
      var c = Math.abs(Math.round(cents));
      var dollars = Math.floor(c / 100);
      var rest = c % 100;
      var withCommas = String(dollars).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var s = '$' + withCommas + ((opts && opts.trim && rest === 0) ? '' : '.' + pad2(rest));
      return neg ? '-' + s : s;
    }

    function isPriorityLine(item, priority) {
      if (!priority) return false;
      if (priority.variantId && Number(item.variant_id || item.id) === Number(priority.variantId)) return true;
      return !!(priority.productHandle && item.handle === priority.productHandle);
    }

    function priorityLines(cart, priority) {
      return ((cart && cart.items) || []).filter(function (it) { return isPriorityLine(it, priority); });
    }

    /* The small order fee line (config.smallOrderFee) is matched the same way as Priority. */
    var isFeeLine = isPriorityLine;

    function feeLines(cart, fee) {
      return ((cart && cart.items) || []).filter(function (it) { return isFeeLine(it, fee); });
    }

    /** Priority Delivery or the small order fee: lines the widget owns, never merchandise. */
    function isExtraLine(item, priority, fee) {
      return isPriorityLine(item, priority) || isFeeLine(item, fee);
    }

    function lineCents(it) {
      return Number(it.final_line_price != null ? it.final_line_price : it.line_price) || 0;
    }

    /**
     * Merchandise subtotal used for every threshold: cart total (after
     * discounts, before delivery fees and taxes) minus the Priority Delivery
     * and small order fee lines, so neither can unlock free delivery or
     * remove the small order fee.
     */
    function merchandiseSubtotalCents(cart, priority, fee) {
      if (!cart) return 0;
      var total = Number(cart.total_price != null ? cart.total_price : cart.items_subtotal_price) || 0;
      ((cart.items) || []).forEach(function (it) {
        if (isExtraLine(it, priority, fee)) total -= lineCents(it);
      });
      return Math.max(0, total);
    }

    function merchandiseItemCount(cart, priority, fee) {
      var n = 0;
      ((cart && cart.items) || []).forEach(function (it) { if (!isExtraLine(it, priority, fee)) n += Number(it.quantity) || 0; });
      return n;
    }

    function deliveryFee(config, zone, subtotalCents) {
      var base = toCents(zone.fee);
      var qualifies = subtotalCents >= toCents(config.freeDeliveryThreshold);
      var over = zone.feeOver100 == null ? 0 : toCents(zone.feeOver100);
      var cents = qualifies ? over : base;
      return { baseCents: base, cents: cents, free: cents === 0, reduced: qualifies && cents < base, qualifies: qualifies };
    }

    function remainingCents(thresholdDollars, subtotalCents) {
      return Math.max(0, toCents(thresholdDollars) - subtotalCents);
    }

    /**
     * Small order fee (replaced the $20 order minimum, 2026-10-21): one fee line
     * while the merchandise subtotal (after discount codes, without the fee and
     * Priority lines) is under the threshold, for Delivery and Shipping alike.
     * Off when the fee product could not be resolved (no variant id).
     */
    function smallOrderFee(config, subtotalCents, itemCount) {
      var f = config.smallOrderFee || {};
      var thresholdCents = toCents(f.threshold);
      var available = !!(f.enabled && f.variantId && thresholdCents > 0);
      var applies = available && itemCount > 0 && subtotalCents < thresholdCents;
      return {
        available: available,
        applies: applies,
        cents: toCents(f.price),
        thresholdCents: thresholdCents,
        remainingCents: applies ? thresholdCents - subtotalCents : 0,
        label: f.label || ''
      };
    }

    /* -------------------------------------------------------- owned lines */

    /**
     * Cart operations so the cart holds exactly one of `lines`' variant with
     * quantity 1 when `want` is true, and none when false.
     * Returns [{endpoint:'/cart/add.js', body}] / [{endpoint:'/cart/change.js', body}]
     */
    function planSingleLineOps(lines, want, variantId) {
      var ops = [];
      if (!want) {
        lines.forEach(function (l) { ops.push({ endpoint: '/cart/change.js', body: { id: l.key, quantity: 0 } }); });
        return ops;
      }
      if (!lines.length) {
        if (variantId) ops.push({ endpoint: '/cart/add.js', body: { items: [{ id: Number(variantId), quantity: 1 }] } });
        return ops;
      }
      if (Number(lines[0].quantity) !== 1) ops.push({ endpoint: '/cart/change.js', body: { id: lines[0].key, quantity: 1 } });
      for (var i = 1; i < lines.length; i++) ops.push({ endpoint: '/cart/change.js', body: { id: lines[i].key, quantity: 0 } });
      return ops;
    }

    function planPriorityOps(cart, want, priority) {
      return planSingleLineOps(priorityLines(cart, priority), want, priority && priority.variantId);
    }

    function planFeeOps(cart, want, fee) {
      return planSingleLineOps(feeLines(cart, fee), want, fee && fee.variantId);
    }

    /* --------------------------------------------------------------- no-ship */

    /**
     * Cart lines that can't be shipped (products tagged no-ship, such as lighters).
     * noShipIds: the variant ids known to be no-ship, as an array or an {id: true} map.
     */
    function noShipLines(cart, noShipIds, priority, fee) {
      var set = {};
      if (Array.isArray(noShipIds)) noShipIds.forEach(function (id) { set[String(id)] = true; });
      else if (noShipIds) Object.keys(noShipIds).forEach(function (id) { if (noShipIds[id]) set[String(id)] = true; });
      return ((cart && cart.items) || []).filter(function (it) {
        return !isExtraLine(it, priority, fee) && Number(it.quantity) > 0 && set[String(it.variant_id)] === true;
      });
    }

    /** Checkout message for a Shipping cart that holds no-ship lines. No dashes. */
    function noShipMessage(lines, canDeliver) {
      lines = lines || [];
      if (!lines.length) return '';
      var name = function (it) { return String(it.product_title || it.title || ''); };
      var lighters = lines.every(function (it) { return /lighter/i.test(name(it)); });
      var head = lighters ? 'Lighters can\'t ship.'
        : lines.length === 1 ? (name(lines[0]) ? name(lines[0]) : 'This item') + ' can\'t ship.'
          : 'Some items in your cart can\'t ship.';
      var pron = lines.length === 1 ? 'it' : 'them';
      return head + (canDeliver ? ' Remove ' + pron + ' or choose Delivery.' : ' Remove ' + pron + ' to check out.');
    }

    /* ------------------------------------------------------------ attributes */

    function blankOwned() {
      var o = {};
      OWNED_KEYS.forEach(function (k) { o[k] = ''; });
      return o;
    }

    function cleanNote(note) {
      return String(note || '').replace(/\r\n?/g, '\n').slice(0, NOTE_MAX).trim();
    }

    /**
     * Cart attributes for a state. Always returns every owned key (cleared keys
     * are ""). Never includes Delivery-Area.
     */
    function buildAttributes(s) {
      var a = blankOwned();
      if (s.noShip) a[ATTR.noShip] = 'yes';
      if (s.method === 'shipping') {
        a[ATTR.method] = 'shipping';
        return a;
      }
      if (s.method !== 'delivery') return a;
      // Checkout-Method=delivery only with a confirmed delivery zone. Apps that hide shipping
      // rates for delivery carts (Shipy) would otherwise leave a cart with no ZIP, a ZIP still
      // being checked or an invalid one at checkout with no way to pay.
      a[ATTR.note] = cleanNote(s.note);
      if (s.pin) a[ATTR.pin] = pinUrl(s.pin);
      if (s.saveNote === false) a[ATTR.saveNote] = '0';
      if (!s.zoneId) return a;
      a[ATTR.method] = 'delivery';
      if (s.zoneId) a[ATTR.locationId] = String(s.zoneId);
      if (s.zoneId && s.slot) {
        a[ATTR.date] = s.slot.dateKey.replace(/-/g, '/');
        a[ATTR.time] = s.slot.label;
        a[ATTR.slotId] = s.slot.id;
        if (s.priority) a[ATTR.priority] = 'yes';
      }
      return a;
    }

    /** Only the owned keys whose value differs from the cart's current attributes. */
    function diffAttributes(current, desired) {
      var out = {};
      var changed = false;
      Object.keys(desired).forEach(function (k) {
        if (k === ATTR.area) return;
        var cur = current && current[k] != null ? String(current[k]) : '';
        if (cur !== String(desired[k])) { out[k] = desired[k]; changed = true; }
      });
      return changed ? out : null;
    }

    /** Legacy line-item property _ZapietId. Start time is local wall-clock with a literal Z. */
    function zapietId(s) {
      if (s.method === 'shipping') return 'M=S';
      if (s.method !== 'delivery' || !s.zoneId || !s.slot) return '';
      return 'M=D&L=' + s.zoneId + '&D=' + s.slot.dateKey + 'T' + s.slot.start + ':00Z&E=' + s.slot.end;
    }

    /* ------------------------------------------------------------------ tags */

    /** "6:00 PM" -> "06:00 PM" */
    function padTime(t) {
      var m = /^\s*(\d{1,2}):(\d{2})\s*([AP]M)\s*$/i.exec(t);
      if (!m) return t.trim();
      return pad2(Number(m[1])) + ':' + m[2] + ' ' + m[3].toUpperCase();
    }

    /**
     * Order tags the Shopify Flow recipe produces (docs/FLOW_TAGS.md), given the
     * order's Delivery-Date ("YYYY/MM/DD") and Delivery-Time ("6:00 PM - 9:00 PM").
     */
    function orderTags(date, time) {
      var d = /^(\d{4})\/(\d{2})\/(\d{2})$/.exec(String(date || ''));
      var tags = ['Local Delivery Order'];
      if (d) tags.push(d[2] + '-' + d[3] + '-' + d[1]);
      if (time) tags.push(String(time).split(' - ').map(padTime).join(' - '));
      return tags;
    }

    /* ---------------------------------------------------------------- config */

    function normalizeConfig(raw) {
      var c = assign({}, raw || {});
      c.timezone = c.timezone || DEFAULT_TZ;
      c.freeDeliveryThreshold = c.freeDeliveryThreshold == null ? 100 : Number(c.freeDeliveryThreshold);
      c.freeShippingThreshold = c.freeShippingThreshold == null ? 200 : Number(c.freeShippingThreshold);
      // The $20 order minimum was replaced by the small order fee (2026-10-21). minOrder is no longer
      // used here; it stays (0) only for the ops app's carrier-rate generator (gen-delivery-zones.cjs).
      c.minOrder = c.minOrder == null ? 0 : Number(c.minOrder);
      c.blackoutDates = Array.isArray(c.blackoutDates) ? c.blackoutDates : [];
      // ZIPs outside every delivery zone even though a ring covers them (off the delivery-area map)
      c.excludeZips = Array.isArray(c.excludeZips)
        ? c.excludeZips.map(function (x) { return normalizeZip(x) || String(x); }) : [];
      c.legacyZapietId = !!c.legacyZapietId;
      // false (default): shoppers inside a delivery zone get Local Delivery only, never Shipping
      c.allowShippingInZone = !!c.allowShippingInZone;
      // true (default): every cart needs a ZIP before checkout, and Shipping carts get a
      // ship-to-state check (/cart/shipping_rates.json) once the subtotal reaches shipCheckMinCents
      c.requireZip = c.requireZip !== false;
      c.shipCheckMinCents = c.shipCheckMinCents == null ? 0 : Number(c.shipCheckMinCents);
      c.metros = c.metros || {};
      c.priority = assign({ enabled: false, productHandle: '', price: 4.99, variantId: null }, c.priority || {});
      c.smallOrderFee = assign({ enabled: false, productHandle: '', price: 5.99, threshold: 25, variantId: null,
        label: 'Small order fee (orders under $25)' }, c.smallOrderFee || {});
      c.smallOrderFee.price = Number(c.smallOrderFee.price);
      c.smallOrderFee.threshold = Number(c.smallOrderFee.threshold);
      c.zones = (c.zones || []).map(function (z) {
        var zone = assign({}, z);
        zone.id = String(zone.id);
        if (Array.isArray(z.zips)) {
          // ZIP-list zone: membership is the list; minMiles/maxMiles are not a ring here.
          // maxMiles carries pinMaxMiles, the door-pin radius from center for these ZIPs.
          zone.zips = z.zips.map(function (x) { return normalizeZip(x) || String(x); });
          zone.minMiles = 0;
          zone.maxMiles = Number(z.pinMaxMiles != null ? z.pinMaxMiles : z.maxMiles);
        } else {
          delete zone.zips;
          zone.minMiles = Number(zone.minMiles || 0);
          zone.maxMiles = Number(zone.maxMiles);
        }
        zone.fee = Number(zone.fee || 0);
        zone.feeOver100 = zone.feeOver100 == null ? 0 : Number(zone.feeOver100);
        zone.daysAhead = Math.max(1, Number(zone.daysAhead || 1));
        zone.prepMinutes = Number(zone.prepMinutes || 0);
        zone.bookUntil = zone.bookUntil === 'end' ? 'end' : 'start';
        zone.center = { lat: Number(zone.center.lat), lng: Number(zone.center.lng) };
        zone.slots = zone.slots || {};
        return zone;
      });
      return c;
    }

    /** Returns a list of human-readable problems; empty means the config is usable. */
    function validateConfig(c) {
      var errs = [];
      if (!c.zones || !c.zones.length) errs.push('No zones configured');
      try { dtf(c.timezone).format(new Date()); } catch (e) { errs.push('Unknown timezone ' + c.timezone); }
      var ids = {};
      var listedIn = {};
      var excluded = {};
      (c.excludeZips || []).forEach(function (x) {
        if (!/^\d{5}$/.test(x)) errs.push('excludeZips: bad ZIP ' + x);
        else excluded[x] = 1;
      });
      (c.zones || []).forEach(function (z) {
        var where = 'zone ' + z.id + ': ';
        if (ids[z.id]) errs.push(where + 'duplicate id');
        ids[z.id] = 1;
        if (!z.metro) errs.push(where + 'missing metro');
        if (Array.isArray(z.zips)) {
          if (!z.zips.length) errs.push(where + 'zips is empty');
          z.zips.forEach(function (x) {
            if (!/^\d{5}$/.test(x)) errs.push(where + 'bad ZIP ' + x);
            else if (excluded[x]) errs.push(where + 'ZIP ' + x + ' is also in excludeZips');
            else if (listedIn[x]) errs.push(where + 'ZIP ' + x + ' is also listed by zone ' + listedIn[x]);
            else listedIn[x] = z.id;
          });
          if (!(Number(z.pinMaxMiles != null ? z.pinMaxMiles : z.maxMiles) > 0)) errs.push(where + 'pinMaxMiles must be greater than 0');
        } else if (!(z.maxMiles > z.minMiles)) errs.push(where + 'maxMiles must be greater than minMiles');
        if (!isFinite(z.center.lat) || !isFinite(z.center.lng)) errs.push(where + 'bad center');
        DAY_KEYS.forEach(function (dk, wd) {
          slotsForWeekday(z, wd).forEach(function (s) {
            try {
              if (parseHHMM(s.end) <= parseHHMM(s.start)) errs.push(where + dk + ' slot ' + s.start + ' ends before it starts');
            } catch (e) { errs.push(where + dk + ' slot has a bad time'); }
          });
          var cut = cutoffForWeekday(z, wd);
          if (cut) { try { parseHHMM(cut); } catch (e) { errs.push(where + dk + ' bad cutoff'); } }
        });
      });
      (c.blackoutDates || []).forEach(function (d) {
        if (!/^\d{4}[-/]\d{2}[-/]\d{2}$/.test(String(d))) errs.push('Bad blackout date ' + d);
      });
      return errs;
    }

    /* -------------------------------------------------------------- evaluate */

    /**
     * Derive everything the widget shows and writes from one input snapshot.
     *
     * input = {
     *   config,                 normalized config
     *   area,                   'austin' | 'lubbock' | 'nationwide' | null
     *   method,                 requested: 'delivery' | 'shipping' | null
     *   zipResult,              result of resolveZip(), or null when no ZIP yet
     *   selection: { slotId, priority, dayKey },
     *   note,
     *   saveNote,               false when the shopper unchecked "Save for future orders"
     *   pin,                    door pin {lat, lng} or null (dropped if outside the metro's area)
     *   cart,                   Shopify /cart.js JSON
     *   nowMs,
     *   zip,                    the ZIP as typed (falls back to zipResult.zip)
     *   zipLoading,             true while the ZIP table is loading
     *   shipCheck               { status: 'ok' | 'none' | 'error' | 'pending' } for this cart + ZIP, or null
     *   noShipIds               variant ids of no-ship products (array or {id: true} map)
     *   noShipPending           true while a cart line's no-ship status is still being looked up
     *   autoSlot                false: never pick a delivery time for the shopper (they choose it);
     *                           a time they chose that is no longer open is still replaced
     * }
     */
    function evaluate(input) {
      var config = input.config;
      var area = input.area || null;
      var hasMetro = !!(area && config.zones.some(function (z) { return z.metro === area; }));
      var pr = config.priority;
      var sof = config.smallOrderFee;
      var subtotal = merchandiseSubtotalCents(input.cart, pr, sof);
      var itemCount = merchandiseItemCount(input.cart, pr, sof);
      var sel = input.selection || {};

      // In zone: the site area is a delivery metro and the ZIP (if any yet) is not outside it.
      // Unless config.allowShippingInZone, those shoppers get Delivery only: Shopify Basic checkout
      // cannot hide the native Local Delivery rate, so a Shipping cart here would reach checkout
      // with no time slot (order #24043).
      var zr0 = input.zipResult;
      // A ZIP inside another metro's zones (or any metro's, while the site area is Nationwide
      // or not chosen yet) means this order goes out by that metro's Local Delivery: the
      // widget switches the site area to `switchTo`. Checkout waits until it has.
      var switchTo = !config.allowShippingInZone && zr0 && zr0.status === 'other_metro' ? zr0.otherMetro : null;
      var zipOutside = !!(zr0 && (zr0.status === 'out_of_zone' || (zr0.status === 'other_metro' && !switchTo)));
      var inZone = (hasMetro && !zipOutside) || !!switchTo;
      var shippingAvailable = !inZone || !!config.allowShippingInZone;

      var method = input.method;
      if (method === 'delivery' && !hasMetro) method = null;
      if (method === 'shipping' && !shippingAvailable) method = hasMetro ? 'delivery' : null;
      if (!method && !switchTo) method = hasMetro ? 'delivery' : (area === 'nationwide' ? 'shipping' : null);
      if (method !== 'delivery' && method !== 'shipping') method = null;

      var out = {
        area: area,
        metro: hasMetro ? area : null,
        metroLabel: hasMetro ? ((config.metros[area] && config.metros[area].label) || area) : null,
        deliveryAvailable: hasMetro,
        inZone: inZone,
        switchTo: switchTo,
        switchToLabel: switchTo ? ((config.metros[switchTo] && config.metros[switchTo].label) || switchTo) : null,
        shippingAvailable: shippingAvailable,
        method: method,
        subtotalCents: subtotal,
        itemCount: itemCount,
        smallOrderFee: smallOrderFee(config, subtotal, itemCount),
        freeShippingRemainingCents: remainingCents(config.freeShippingThreshold, subtotal),
        freeDeliveryRemainingCents: remainingCents(config.freeDeliveryThreshold, subtotal),
        zip: input.zipResult || null,
        zone: null,
        days: [],
        dayKey: null,
        slot: null,
        earliest: null,
        priority: false,
        priorityAvailable: !!(pr && pr.enabled && pr.variantId),
        fee: null,
        slotChanged: null,
        pin: input.pin && hasMetro && checkPin(config, area, input.pin, input.zip != null ? input.zip : (zr0 && zr0.zip)).ok ? toPoint(input.pin) : null,
        noShipLines: noShipLines(input.cart, input.noShipIds, pr, sof),
        noShipCanDeliver: hasMetro && !zipOutside && !switchTo,
        noShipMessage: '',
        complete: false,
        blockReason: null
      };

      if (method === 'delivery') {
        var zr = input.zipResult;
        // The zone is confirmed only for the ZIP as typed, once its check has finished.
        var typed = input.zip != null ? normalizeZip(input.zip) : (zr && zr.zip);
        if (zr && zr.status === 'ok' && zr.metro === area && !input.zipLoading && typed === zr.zip) {
          out.zone = zr.zone;
          out.days = buildDays(config, zr.zone, input.nowMs);
          out.earliest = earliestSlot(out.days);
          out.fee = deliveryFee(config, zr.zone, subtotal);
          var wanted = sel.slotId ? findSlot(out.days, sel.slotId) : null;
          var prevParsed = sel.slotId ? parseSlotId(sel.slotId) : null;
          if (sel.priority && out.priorityAvailable) {
            out.slot = out.earliest;
            out.priority = !!out.earliest;
            if (sel.slotId && out.earliest && sel.slotId !== out.earliest.id) {
              out.slotChanged = { from: sel.slotId, to: out.earliest.id, priority: true };
            }
          } else if (wanted && wanted.available) {
            out.slot = wanted;
          } else if (input.autoSlot === false && !sel.slotId) {
            out.slot = null;
          } else {
            var after = prevParsed && prevParsed.zoneId === zr.zone.id
              ? zonedTimeToInstant(prevParsed.dateKey, prevParsed.start, config.timezone) : -Infinity;
            out.slot = nextAvailableSlot(out.days, after);
            if (sel.slotId && prevParsed && prevParsed.zoneId === zr.zone.id) {
              out.slotChanged = { from: sel.slotId, to: out.slot ? out.slot.id : null, priority: false };
            }
          }
          out.dayKey = out.slot ? out.slot.dateKey : (out.earliest ? out.earliest.dateKey : (out.days[0] && out.days[0].dateKey));
          if (sel.dayKey && out.days.some(function (d) { return d.dateKey === sel.dayKey; }) && !sel.priority) {
            out.dayKey = sel.dayKey;
          }
        }
      }

      out.attributes = buildAttributes({
        method: method,
        zoneId: out.zone ? out.zone.id : null,
        slot: out.slot,
        priority: out.priority,
        note: input.note,
        pin: out.pin,
        saveNote: input.saveNote,
        noShip: out.noShipLines.length > 0
      });
      if (out.noShipLines.length) out.noShipMessage = noShipMessage(out.noShipLines, out.noShipCanDeliver);

      // Shipping: a ZIP is required (config.requireZip), and once the subtotal reaches
      // shipCheckMinCents (default 0: every cart) the cart must be shippable to the ZIP's state.
      var zip = normalizeZip(input.zip != null ? input.zip : (zr0 && zr0.zip));
      var needZip = method === 'shipping' && config.requireZip;
      out.zipValue = zip;
      out.shipState = needZip && zip ? zipToState(zip) : null;
      out.shipCheckNeeded = !!(needZip && zip && !input.zipLoading && out.shipState && itemCount > 0 &&
        subtotal >= config.shipCheckMinCents);
      out.shipCheck = out.shipCheckNeeded ? (input.shipCheck && input.shipCheck.status ? input.shipCheck.status : 'pending') : null;

      if (itemCount === 0) out.blockReason = 'empty';
      else if (switchTo) out.blockReason = 'area';
      else if (!method) out.blockReason = 'method';
      else if (method === 'shipping' && out.noShipLines.length) out.blockReason = 'no_ship';
      else if (method === 'shipping' && input.noShipPending) out.blockReason = 'loading';
      else if (method === 'delivery' && !out.zone) out.blockReason = 'zip';
      else if (method === 'delivery' && !out.slot) out.blockReason = out.earliest ? 'time' : 'slot';
      else if (needZip && !zip) out.blockReason = 'zip';
      else if (needZip && input.zipLoading) out.blockReason = 'loading';
      else if (out.shipCheck === 'none') out.blockReason = 'ship_blocked';
      else if (out.shipCheck === 'pending') out.blockReason = 'ship_checking';
      out.complete = !out.blockReason;
      return out;
    }

    return {
      DAY_KEYS: DAY_KEYS,
      ATTR: ATTR,
      OWNED_KEYS: OWNED_KEYS,
      NOTE_MAX: NOTE_MAX,
      zonedParts: zonedParts,
      zonedTimeToInstant: zonedTimeToInstant,
      addDays: addDays,
      weekdayOf: weekdayOf,
      parseHHMM: parseHHMM,
      formatTime12: formatTime12,
      slotLabel: slotLabel,
      shortDate: shortDate,
      haversineMiles: haversineMiles,
      toPoint: toPoint,
      pinUrl: pinUrl,
      parsePin: parsePin,
      metroCenter: metroCenter,
      checkPin: checkPin,
      normalizeZip: normalizeZip,
      zipToState: zipToState,
      STATE_NAMES: STATE_NAMES,
      shipCheckKey: shipCheckKey,
      zonesForMetro: zonesForMetro,
      isZipZone: isZipZone,
      isExcludedZip: isExcludedZip,
      zipZoneFor: zipZoneFor,
      matchRing: matchRing,
      resolveZip: resolveZip,
      slotsForWeekday: slotsForWeekday,
      cutoffForWeekday: cutoffForWeekday,
      isBlackout: isBlackout,
      slotIdFor: slotIdFor,
      parseSlotId: parseSlotId,
      slotBookability: slotBookability,
      buildDays: buildDays,
      earliestSlot: earliestSlot,
      findSlot: findSlot,
      nextAvailableSlot: nextAvailableSlot,
      toCents: toCents,
      formatMoney: formatMoney,
      isPriorityLine: isPriorityLine,
      priorityLines: priorityLines,
      isFeeLine: isFeeLine,
      feeLines: feeLines,
      isExtraLine: isExtraLine,
      merchandiseSubtotalCents: merchandiseSubtotalCents,
      merchandiseItemCount: merchandiseItemCount,
      deliveryFee: deliveryFee,
      smallOrderFee: smallOrderFee,
      planSingleLineOps: planSingleLineOps,
      planPriorityOps: planPriorityOps,
      planFeeOps: planFeeOps,
      noShipLines: noShipLines,
      noShipMessage: noShipMessage,
      cleanNote: cleanNote,
      buildAttributes: buildAttributes,
      diffAttributes: diffAttributes,
      zapietId: zapietId,
      padTime: padTime,
      orderTags: orderTags,
      normalizeConfig: normalizeConfig,
      validateConfig: validateConfig,
      evaluate: evaluate
    };
  });

  var E = module.exports;
  // ---- src/widget.js ----
  /*
   * uforiq-schedule widget (storefront UI, checkout gate, cart sync).
   * Inlined after src/engine.js by scripts/build.js; `E` is the engine.
   * ES2017, no framework. Only talks to /cart.js, /cart/update.js,
   * /cart/add.js and /cart/change.js, plus GET /cart/shipping_rates.json for the
   * ship-to-state check and GET /products/<handle>.js for the no-ship tag of a
   * cart line the page did not describe (both read only).
   */
  /* global E */
  var VERSION = '1.0.0';
  var STORE_KEY = 'uqs:v1';
  var NOTE_KEY = 'uqs:delivery-note';   // saved delivery instructions (plain string)
  var SAVE_KEY = 'uqs:save-note';       // "0" when the shopper unchecked "Save for future orders"
  var ATTR = E.ATTR;
  var opts = assign({ debounceMs: 400, revalidateMs: 60000, autoMount: true, shipCheckDebounceMs: 400, shipCheckTimeoutMs: 5000, feeDebounceMs: 350, noShipTimeoutMs: 4000 },
    window.UforiqScheduleOptions || {});

  function assign(target) {
    for (var i = 1; i < arguments.length; i++) {
      var src = arguments[i];
      if (!src) continue;
      for (var k in src) if (Object.prototype.hasOwnProperty.call(src, k)) target[k] = src[k];
    }
    return target;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var store = {
    read: function () {
      try { return JSON.parse(window.localStorage.getItem(STORE_KEY) || '{}') || {}; } catch (e) { return {}; }
    },
    write: function (patch) {
      try {
        var cur = store.read();
        window.localStorage.setItem(STORE_KEY, JSON.stringify(assign(cur, patch)));
      } catch (e) { /* storage unavailable: private mode, blocked */ }
    }
  };

  /** Plain string localStorage values; every access is guarded (private mode, blocked storage). */
  var ls = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* unavailable */ } },
    remove: function (k) { try { window.localStorage.removeItem(k); } catch (e) { /* unavailable */ } }
  };

  function reducedMotion() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }

  /* ------------------------------------------------------------- shared state */

  var S = {
    config: null,
    cart: null,
    area: null,
    method: null,          // requested by the shopper (or restored); evaluate() decides the effective one
    methodExplicit: false,
    zip: '',
    zipResult: null,
    zipStatus: null,       // 'loading' | 'unavailable' | null
    selection: { slotId: null, priority: false, dayKey: null },
    note: '',
    notePrefilled: false,  // the box holds saved instructions the shopper has not touched on this cart
    saveNote: true,        // "Save for future orders"
    pin: null,             // door pin {lat, lng} for this order only (never stored locally)
    mapsKey: '',           // Google Maps JS key from the theme settings; blank hides the pin feature
    customerNote: null,    // logged-in customer's saved instructions (metafield), null when logged out
    model: null,
    ready: false,
    initPromise: null,
    nowOverride: opts.now != null ? opts.now : null,
    writeTimer: null,
    queue: Promise.resolve(),
    inflight: 0,
    busy: false,
    priorityErrorAt: 0,
    feeTimer: null,        // debounced small order fee sync
    feeErrorAt: 0,         // last failed (or loop-stopped) fee sync: back off for 10 s
    feeRuns: [],           // times of fee syncs that changed the cart (loop breaker)
    lastEvent: '',
    bypass: false,
    pinDialog: null,
    shipCache: {},         // shipCheckKey -> { status: 'ok' | 'none' | 'error' }
    shipPendingKey: null,
    shipTimer: null,
    shipWarned: false,
    switchNotice: null,    // metro the widget just switched the site area to (for the "Good news" line)
    autoShipZip: null,     // out-of-area ZIP that switched this order from Delivery to Shipping
    awaitTime: false,      // a typed ZIP moved Shipping to Delivery: the shopper picks the time (no auto-pick)
    // no-ship products (tag no-ship, e.g. lighters). Liquid prints the cart's no-ship variant ids in
    // script[data-uqs-noship] (this snippet and the drawer's re-rendered part); lines it did not
    // describe are looked up once by product handle.
    noShip: { ids: {}, seen: {}, pending: {}, looked: {} },
    started: false
  };
  var views = [];
  var uid = 0;

  function now() {
    if (typeof S.nowOverride === 'function') return S.nowOverride();
    if (S.nowOverride != null) return S.nowOverride;
    return Date.now();
  }

  /* -------------------------------------------------------------------- cart */

  function routeRoot() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof r === 'string' && r ? r.replace(/\/?$/, '/') : '/';
  }

  function cartRequest(path, body) {
    var url = routeRoot() + path.replace(/^\//, '');
    var init = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (body) {
      init.method = 'POST';
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(body);
    }
    S.inflight++;
    return window.fetch(url, init).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) {
          var err = new Error((json && (json.description || json.message)) || ('HTTP ' + res.status));
          err.status = res.status;
          throw err;
        }
        return json;
      });
    }).then(function (json) { S.inflight--; return json; }, function (err) { S.inflight--; throw err; });
  }

  function enqueue(fn) {
    var p = S.queue.then(fn);
    S.queue = p.catch(function () {});
    return p;
  }

  function fetchCart() {
    return cartRequest('/cart.js').then(function (cart) { S.cart = cart; return cart; });
  }

  /* ---------------------------------------------------------------- no-ship */

  var NO_SHIP_TAG = 'no-ship';

  function idList(v) {
    if (Array.isArray(v)) return v;
    return String(v == null ? '' : v).split(/[\s,]+/);
  }

  /** Merge every script[data-uqs-noship] on the page: {"seen": [ids], "ids": [ids], "extra": "ids"}. */
  function scanNoShip() {
    var ns = S.noShip;
    Array.prototype.slice.call(document.querySelectorAll('script[data-uqs-noship]')).forEach(function (n) {
      var txt = n.textContent;
      if (n.__uqsNoShip === txt) return;
      n.__uqsNoShip = txt;
      var j;
      try { j = JSON.parse(txt); } catch (e) { return; }
      if (!j) return;
      idList(j.seen).forEach(function (id) { if (/^\d+$/.test(String(id))) ns.seen[String(id)] = true; });
      idList(j.ids).concat(idList(j.extra)).forEach(function (id) {
        id = String(id).trim();
        if (!/^\d+$/.test(id)) return;
        ns.ids[id] = true;
        ns.seen[id] = true;
      });
    });
  }

  function hasNoShipTag(tags) {
    return idList(tags).some(function (t) { return String(t).trim().toLowerCase() === NO_SHIP_TAG; });
  }

  /** Cart lines Liquid did not describe: read the product's tags once (GET, read only). Fails open. */
  function lookupNoShip() {
    var ns = S.noShip;
    var pr = S.config && S.config.priority;
    var fee = S.config && S.config.smallOrderFee;
    ((S.cart && S.cart.items) || []).forEach(function (it) {
      var vid = String(it.variant_id);
      var handle = it.handle;
      if (ns.seen[vid] || !handle || ns.looked[handle] || E.isExtraLine(it, pr, fee)) return;
      ns.looked[handle] = true;
      ns.pending[vid] = true;
      var done = function (product) {
        if (product && Array.isArray(product.variants)) {
          var tagged = hasNoShipTag(product.tags);
          product.variants.forEach(function (v) {
            ns.seen[String(v.id)] = true;
            if (tagged) ns.ids[String(v.id)] = true;
          });
          if (tagged) ns.ids[vid] = true;
        }
        ns.seen[vid] = true;
        delete ns.pending[vid];
        recompute('noship');
      };
      var timer = null;
      new Promise(function (resolve, reject) {
        timer = setTimeout(function () { reject(new Error('timeout')); }, opts.noShipTimeoutMs);
        Promise.resolve().then(function () {
          return window.fetch(routeRoot() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
        }).then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        }).then(resolve, reject);
      }).then(function (product) { clearTimeout(timer); done(product); }, function (err) {
        clearTimeout(timer);
        if (window.console) console.warn('[uforiq-schedule] no-ship lookup failed for ' + handle, err);
        done(null);
      });
    });
  }

  function noShipPending() {
    var ns = S.noShip;
    return ((S.cart && S.cart.items) || []).some(function (it) { return ns.pending[String(it.variant_id)]; });
  }

  /**
   * "Remove" in the no-ship box: takes every no-ship line out of the cart. The theme re-renders on
   * uforiq:schedule:cart-changed (the drawer, and /cart via assets/uq-cart-page-fee.js).
   */
  function removeNoShip() {
    var lines = (S.model && S.model.noShipLines) || [];
    if (!lines.length || S.busy) return;
    S.busy = true;
    renderAll();
    enqueue(function () {
      return lines.reduce(function (p, it) {
        return p.then(function () { return cartRequest('/cart/change.js', { id: it.key, quantity: 0 }); });
      }, Promise.resolve()).then(fetchCart);
    }).then(function (cart) {
      S.busy = false;
      dispatch('uforiq:schedule:cart-changed', { cart: cart, reason: 'no-ship-removed' });
      recompute('noship');
      announce(lines.length === 1 ? 'Removed ' + (lines[0].product_title || 'the item') + ' from your cart.' : 'Removed the items that can\'t ship.');
    }, function (err) {
      S.busy = false;
      if (window.console) console.warn('[uforiq-schedule] removing no-ship items failed', err);
      announce('We could not remove that item. Please remove it from your cart.', 'alert');
      return fetchCart().catch(function () {}).then(function () { recompute('noship'); });
    });
  }

  /* ---------------------------------------------------- ship-to-state check */

  /**
   * Shopify's AJAX rates for this cart at a US ZIP + state. Resolves to the
   * shipping_rates array; rejects on an HTTP error, a timeout or a body that is
   * not the expected JSON (callers fail open).
   */
  function fetchShippingRates(zip, province) {
    var url = routeRoot() + 'cart/shipping_rates.json?shipping_address[zip]=' + encodeURIComponent(zip) +
      '&shipping_address[country]=US&shipping_address[province]=' + encodeURIComponent(province);
    var ctrl = null;
    try { ctrl = typeof AbortController === 'function' ? new AbortController() : null; } catch (e) { ctrl = null; }
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () {
        try { if (ctrl) ctrl.abort(); } catch (e) { /* ignore */ }
        reject(new Error('shipping rates timed out'));
      }, opts.shipCheckTimeoutMs);
      var init = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
      if (ctrl) init.signal = ctrl.signal;
      Promise.resolve().then(function () { return window.fetch(url, init); }).then(function (res) {
        if (!res || !res.ok) throw new Error('shipping rates HTTP ' + (res && res.status));
        return res.json();
      }).then(function (json) {
        if (!json || !Array.isArray(json.shipping_rates)) throw new Error('shipping rates: unexpected response');
        clearTimeout(timer);
        resolve(json.shipping_rates);
      }).catch(function (err) { clearTimeout(timer); reject(err); });
    });
  }

  /** Debounced check for the current cart + ZIP; one request per cache key. */
  function scheduleShipCheck(m, key) {
    if (!m.shipCheckNeeded || S.shipCache[key] || S.shipPendingKey === key) return;
    S.shipPendingKey = key;
    clearTimeout(S.shipTimer);
    var zip = m.zipValue;
    var code = m.shipState.code;
    S.shipTimer = setTimeout(function () {
      S.shipTimer = null;
      fetchShippingRates(zip, code).then(function (rates) {
        return { status: rates.length ? 'ok' : 'none' };
      }, function (err) {
        if (!S.shipWarned && window.console) {
          S.shipWarned = true;
          console.warn('[uforiq-schedule] shipping check failed, allowing checkout', err);
        }
        return { status: 'error' };
      }).then(function (res) {
        S.shipCache[key] = res;
        if (S.shipPendingKey === key) S.shipPendingKey = null;
        recompute('shipcheck');
      });
    }, opts.shipCheckDebounceMs);
  }

  /* ------------------------------------------------------------------ config */

  function readJsonScript(el, sel) {
    var node = el && el.querySelector(sel);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) {
      if (window.console) console.error('[uforiq-schedule] bad JSON in ' + sel, e);
      return null;
    }
  }

  /** Server-rendered cart JSON (data-uqs-cart, HTML-escaped by Liquid). */
  function readCartAttr(el) {
    var raw = el && el.getAttribute('data-uqs-cart');
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function loadConfig(el) {
    var raw = readJsonScript(el, 'script[data-uqs-config]') || window.UforiqScheduleConfig || null;
    if (!raw) return null;
    var cfg = E.normalizeConfig(raw);
    var pr = readJsonScript(el, 'script[data-uqs-priority]');
    if (pr) {
      if (pr.variantId) cfg.priority.variantId = Number(pr.variantId);
      if (pr.available === false) cfg.priority.enabled = false;
      if (pr.price != null && !isNaN(Number(pr.price))) cfg.priority.price = Number(pr.price) / 100;
    }
    var fee = readJsonScript(el, 'script[data-uqs-fee]');
    if (fee) {
      if (fee.variantId) cfg.smallOrderFee.variantId = Number(fee.variantId);
      if (fee.available === false) cfg.smallOrderFee.enabled = false;
      if (fee.price != null && !isNaN(Number(fee.price))) cfg.smallOrderFee.price = Number(fee.price) / 100;
    } else {
      cfg.smallOrderFee.variantId = null; // no fee product resolved on the server: no fee
    }
    var errs = E.validateConfig(cfg);
    if (errs.length && window.console) console.warn('[uforiq-schedule] config problems:', errs);
    cfg.zipsSrc = el.getAttribute('data-zips-src') || cfg.zipsSrc || '';
    S.mapsKey = (el.getAttribute('data-maps-key') || '').trim();
    S.customerNote = el.hasAttribute('data-uqs-customer-note') ? el.getAttribute('data-uqs-customer-note') : null;
    return cfg;
  }

  /* -------------------------------------------------------------------- zips */

  var zipsPromise = null;
  function ensureZips() {
    if (window.UforiqScheduleZips) return Promise.resolve(window.UforiqScheduleZips);
    if (zipsPromise) return zipsPromise;
    var src = S.config && S.config.zipsSrc;
    if (!src) return Promise.reject(new Error('No ZIP table source'));
    zipsPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () {
        if (window.UforiqScheduleZips) resolve(window.UforiqScheduleZips);
        else reject(new Error('ZIP table did not load'));
      };
      s.onerror = function () { zipsPromise = null; reject(new Error('ZIP table failed to load')); };
      document.head.appendChild(s);
    });
    return zipsPromise;
  }

  function resolveCurrentZip() {
    if (!E.normalizeZip(S.zip)) {
      S.zipResult = S.zip ? { status: 'invalid', zip: S.zip } : null;
      S.zipStatus = null;
      return Promise.resolve();
    }
    S.zipStatus = 'loading';
    return ensureZips().then(function (table) {
      S.zipStatus = null;
      S.zipResult = E.resolveZip(S.zip, S.config, table, S.area);
    }, function () {
      S.zipStatus = 'unavailable';
      S.zipResult = null;
    });
  }

  /* -------------------------------------------------------------------- area */

  function readArea() {
    var loc = window.UforiqLocation;
    if (loc && typeof loc.get === 'function') {
      try {
        var v = loc.get();
        if (v) return String(v).toLowerCase();
      } catch (e) { /* fall through */ }
    }
    var a = S.cart && S.cart.attributes && S.cart.attributes[ATTR.area];
    return a ? String(a).toLowerCase() : null;
  }

  /* ---------------------------------------------------------------- recompute */

  function evaluateNow() {
    return E.evaluate({
      config: S.config,
      area: S.area,
      method: S.method,
      zipResult: S.zipResult,
      selection: S.selection,
      note: S.note,
      saveNote: S.saveNote,
      pin: S.pin,
      cart: S.cart,
      nowMs: now(),
      zip: S.zip,
      zipLoading: S.zipStatus === 'loading',
      shipCheck: S.shipCache[E.shipCheckKey(S.cart, S.zip)] || null,
      noShipIds: S.noShip.ids,
      noShipPending: noShipPending(),
      autoSlot: !S.awaitTime
    });
  }

  /**
   * Delivery with a ZIP outside every delivery zone: the order ships. Selects Shipping
   * (written as Checkout-Method=shipping, delivery day/time cleared) with no extra tap.
   */
  function autoShip(m, reason) {
    var r = S.zipResult;
    if (m.method !== 'delivery' || !m.shippingAvailable || S.zipStatus === 'loading') return false;
    if (!r || r.status !== 'out_of_zone' || r.zip !== E.normalizeZip(S.zip)) return false;
    S.method = 'shipping';
    S.methodExplicit = false;
    S.awaitTime = false;
    S.selection = { slotId: null, priority: false, dayKey: null };
    S.autoShipZip = r.zip;
    store.write({ method: 'shipping' });
    if (S.ready && reason === 'zip') announce('We don\'t deliver to ' + r.zip + ' yet, so this order will ship.');
    return true;
  }

  function recompute(reason) {
    if (!S.config || !S.cart) return;
    scanNoShip();
    var prevSlot = S.model && S.model.slot;
    var shipKey = E.shipCheckKey(S.cart, S.zip);
    var m = evaluateNow();
    if (autoShip(m, reason)) m = evaluateNow();
    S.model = m;
    // In zone with Shipping turned off: a Shipping choice restored from old cart attributes or
    // this browser becomes Delivery (the attribute is rewritten by the write below). Waits for
    // the ZIP check so a saved out-of-zone ZIP keeps its Shipping choice.
    if (S.method === 'shipping' && !m.shippingAvailable && m.deliveryAvailable && S.ready && S.zipStatus !== 'loading') {
      S.method = 'delivery';
      store.write({ method: 'delivery' });
    }
    if (S.pin && !m.pin && m.deliveryAvailable) S.pin = null; // outside this metro's area

    if (m.method === 'delivery' && m.zone) {
      if (m.slotChanged && S.ready && reason !== 'select') {
        var from = E.parseSlotId(m.slotChanged.from);
        var fromLabel = from ? labelForSlotId(from) : 'your time';
        announce(m.slot
          ? 'The ' + fromLabel + ' delivery time is no longer available. We picked ' + dayWord(m.slot.dateKey) + ', ' + m.slot.label + ' instead.'
          : 'The ' + fromLabel + ' delivery time is no longer available, and no other times are open right now.', 'alert');
      } else if (S.ready && reason === 'tick' && prevSlot && m.slot && prevSlot.id !== m.slot.id) {
        announce('Delivery time updated to ' + dayWord(m.slot.dateKey) + ', ' + m.slot.label + '.');
      }
      S.selection.slotId = m.slot ? m.slot.id : null;
      S.selection.priority = !!m.priority;
    }

    if (S.started) lookupNoShip();
    if (S.ready) {
      scheduleWrite();
      syncPriority();
      syncFee();
      scheduleShipCheck(m, shipKey);
    }
    toggleExpress();
    renderAll();
    emitChange();
  }

  function labelForSlotId(p) {
    var zone = S.config.zones.filter(function (z) { return z.id === p.zoneId; })[0];
    var def = zone && E.slotsForWeekday(zone, E.weekdayOf(p.dateKey)).filter(function (s) { return s.start === p.start; })[0];
    return dayWord(p.dateKey) + ' ' + (def ? (def.label || E.slotLabel(def.start, def.end)) : E.formatTime12(p.start));
  }

  function dayWord(dateKey) {
    var today = E.zonedParts(now(), S.config.timezone).dateKey;
    if (dateKey === today) return 'today';
    if (dateKey === E.addDays(today, 1)) return 'tomorrow';
    return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][E.weekdayOf(dateKey)];
  }

  /* ---------------------------------------------------------- attribute writes */

  function desiredDiff() {
    if (!S.model || !S.cart) return null;
    return E.diffAttributes(S.cart.attributes || {}, S.model.attributes);
  }

  function scheduleWrite() {
    if (!desiredDiff() && !zapietOp()) return;
    clearTimeout(S.writeTimer);
    S.writeTimer = setTimeout(flush, opts.debounceMs);
  }

  /** Write pending attribute changes now. Resolves once the cart has them. */
  function flush() {
    clearTimeout(S.writeTimer);
    S.writeTimer = null;
    return enqueue(function () {
      var diff = desiredDiff();
      var p = diff
        ? cartRequest('/cart/update.js', { attributes: diff }).then(function (cart) { S.cart = cart; })
        : Promise.resolve();
      return p.then(function () {
        var op = zapietOp();
        if (!op) return null;
        return cartRequest('/cart/change.js', op).then(function (cart) { S.cart = cart; });
      });
    }).then(function () { recompute('write'); }, function (err) {
      if (window.console) console.warn('[uforiq-schedule] cart update failed', err);
    }).then(function () { return feeNow(); });
  }

  function hasPendingWrite() {
    return !!(S.writeTimer || S.inflight || desiredDiff() || zapietOp());
  }

  /** Attribute writes or a small order fee change still to reach the cart (checkout waits for both). */
  function pendingForCheckout() {
    return hasPendingWrite() || feePending();
  }

  /** Legacy _ZapietId line property (config.legacyZapietId). */
  function zapietOp() {
    if (!S.config || !S.config.legacyZapietId || !S.model || !S.cart) return null;
    var pr = S.config.priority;
    var sof = S.config.smallOrderFee;
    var line = (S.cart.items || []).filter(function (it) { return !E.isExtraLine(it, pr, sof); })[0];
    if (!line) return null;
    var want = S.model.complete || S.model.method === 'shipping'
      ? E.zapietId({ method: S.model.method, zoneId: S.model.zone && S.model.zone.id, slot: S.model.slot })
      : '';
    var props = assign({}, line.properties || {});
    if ((props._ZapietId || '') === want) return null;
    if (want) props._ZapietId = want; else delete props._ZapietId;
    return { id: line.key, quantity: line.quantity, properties: props };
  }

  /* ----------------------------------------------------------- priority line */

  function syncPriority() {
    if (S.busy || !S.ready || S.zipStatus === 'loading' || !S.model || !S.cart) return;
    if (Date.now() - S.priorityErrorAt < 10000) return;
    var want = !!(S.model.priority && S.model.itemCount > 0);
    var ops = E.planPriorityOps(S.cart, want, S.config.priority);
    if (!ops.length) return;
    S.busy = true;
    renderAll();
    enqueue(function () {
      return ops.reduce(function (p, op) {
        return p.then(function () { return cartRequest(op.endpoint, op.body); });
      }, Promise.resolve()).then(fetchCart);
    }).then(function (cart) {
      S.busy = false;
      dispatch('uforiq:schedule:cart-changed', { cart: cart, reason: want ? 'priority-added' : 'priority-removed' });
      recompute('priority');
    }, function (err) {
      S.busy = false;
      S.priorityErrorAt = Date.now();
      if (window.console) console.warn('[uforiq-schedule] priority line update failed', err);
      if (want) {
        S.selection.priority = false;
        announce('We could not add Priority right now. Your delivery time is still saved.', 'alert');
      }
      return fetchCart().catch(function () {}).then(function () { recompute('priority'); });
    });
  }

  /* ------------------------------------------------------- small order fee */

  /*
   * Small order fee (replaced the $20 order minimum, 2026-10-21): the cart holds exactly one
   * fee line while the merchandise subtotal (after discount codes, without the fee and Priority
   * lines) is under the threshold, for Delivery and Shipping alike, and none at or above it.
   * The fee never counts toward its own threshold, so adding it can't remove it again. Syncs
   * are debounced (fast stepper clicks settle first), re-read /cart.js right before planning,
   * back off for 10 s after an error and stop after 6 cart changes in 30 s (loop breaker).
   * flush() (checkout) runs a pending sync at once. If the fee product can't be resolved the
   * feature is off and checkout is never blocked by it.
   */
  function feeWanted(m) {
    return !!(m && m.smallOrderFee && m.smallOrderFee.applies);
  }

  function feeOps() {
    if (!S.ready || !S.model || !S.cart || !S.config) return [];
    if (Date.now() - S.feeErrorAt < 10000) return [];
    return E.planFeeOps(S.cart, feeWanted(S.model), S.config.smallOrderFee);
  }

  function feePending() {
    return !!S.feeTimer || feeOps().length > 0;
  }

  function syncFee() {
    if (!feeOps().length) {
      clearTimeout(S.feeTimer);
      S.feeTimer = null;
      return;
    }
    clearTimeout(S.feeTimer);
    S.feeTimer = setTimeout(function () { S.feeTimer = null; runFeeSync(); }, opts.feeDebounceMs);
  }

  /** Run a pending fee sync now (checkout). Resolves once the cart has the right fee line. */
  function feeNow() {
    if (!S.feeTimer && !feeOps().length) return Promise.resolve();
    clearTimeout(S.feeTimer);
    S.feeTimer = null;
    return S.queue.then(runFeeSync);
  }

  function runFeeSync() {
    if (S.busy || S.zipStatus === 'loading') return Promise.resolve(); // recompute after that work calls syncFee again
    if (!feeOps().length) return Promise.resolve();
    var t = Date.now();
    S.feeRuns = S.feeRuns.filter(function (x) { return t - x < 30000; });
    if (S.feeRuns.length >= 6) {
      S.feeErrorAt = t + 20000; // pause 30 s
      if (window.console) console.warn('[uforiq-schedule] small order fee changed the cart too often; pausing');
      return Promise.resolve();
    }
    var changed = null;
    S.busy = true;
    renderAll();
    return enqueue(function () {
      // Plan from a fresh cart: another script may have changed it since our copy.
      return fetchCart().then(function (cart) {
        var want = feeWanted(evaluateNow());
        var ops = E.planFeeOps(cart, want, S.config.smallOrderFee);
        if (!ops.length) return null;
        changed = want ? 'fee-added' : 'fee-removed';
        S.feeRuns.push(Date.now());
        return ops.reduce(function (p, op) {
          return p.then(function () { return cartRequest(op.endpoint, op.body); });
        }, Promise.resolve()).then(fetchCart);
      });
    }).then(function (cart) {
      S.busy = false;
      if (changed) dispatch('uforiq:schedule:cart-changed', { cart: cart, reason: changed });
      recompute('fee');
    }, function (err) {
      S.busy = false;
      S.feeErrorAt = Date.now();
      if (window.console) console.warn('[uforiq-schedule] small order fee update failed', err);
      return fetchCart().catch(function () {}).then(function () { recompute('fee'); });
    });
  }

  /* ------------------------------------------------------------------ events */

  function dispatch(name, detail) {
    var ev;
    try { ev = new CustomEvent(name, { detail: detail }); } catch (e) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent(name, false, false, detail);
    }
    window.dispatchEvent(ev);
  }

  function emitChange() {
    var st = publicState();
    var detail = {
      method: st.method, complete: st.complete, zoneId: st.zoneId,
      date: st.date, slotLabel: st.slotLabel, priority: st.priority
    };
    var json = JSON.stringify(detail);
    if (json === S.lastEvent) return;
    S.lastEvent = json;
    dispatch('uforiq:schedule:change', detail);
  }

  function publicState() {
    var m = S.model;
    if (!m) return { method: null, complete: false, zoneId: null, date: null, slotLabel: null, priority: false, ready: false };
    return {
      ready: S.ready,
      method: m.method,
      complete: isComplete(),
      blockReason: blockReason(),
      area: m.area,
      zip: E.normalizeZip(S.zip),
      zoneId: m.zone ? m.zone.id : null,
      date: m.slot ? m.slot.dateKey.replace(/-/g, '/') : null,
      slotId: m.slot ? m.slot.id : null,
      slotLabel: m.slot ? m.slot.label : null,
      priority: !!m.priority,
      note: E.cleanNote(S.note),
      saveNote: S.saveNote,
      pin: m.pin ? { lat: m.pin.lat, lng: m.pin.lng } : null,
      switchTo: m.switchTo,
      shipState: m.shipState ? m.shipState.code : null,
      shipCheck: m.shipCheck,
      subtotalCents: m.subtotalCents,
      smallOrderFee: m.smallOrderFee ? {
        applies: m.smallOrderFee.applies, cents: m.smallOrderFee.cents,
        thresholdCents: m.smallOrderFee.thresholdCents, remainingCents: m.smallOrderFee.remainingCents
      } : null,
      attributes: assign({}, m.attributes)
    };
  }

  function blockReason() {
    if (!S.model) return 'loading';
    if (S.busy) return 'busy';
    return S.model.blockReason;
  }

  function isComplete() { return !!(S.ready && S.model && S.model.complete && !S.busy); }

  /* --------------------------------------------------------- express buttons */

  function toggleExpress() {
    var hide = !(S.model && S.model.method === 'shipping' && S.model.complete);
    document.documentElement.classList.toggle('uqs-hide-express', hide);
  }

  /* --------------------------------------------------------- checkout gating */

  var CHECKOUT_PATH = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkouts?(?:\/|$)/i;

  function checkoutTrigger(target) {
    if (!target || !target.closest) return null;
    var el = target.closest('[data-uq-checkout], a[href], button[name="checkout"], input[name="checkout"]');
    if (!el) return null;
    if (el.hasAttribute('data-uq-checkout')) return el;
    if (el.tagName === 'A') {
      try {
        var u = new URL(el.getAttribute('href'), window.location.href);
        if (u.origin === window.location.origin && CHECKOUT_PATH.test(u.pathname)) return el;
      } catch (e) { return null; }
      return null;
    }
    return el; // button/input named checkout
  }

  function blockMessage(reason) {
    var m = S.model;
    switch (reason) {
      case 'loading': return 'One moment, loading delivery options.';
      case 'busy': return 'One moment, updating your cart.';
      case 'empty': return 'Your cart is empty.';
      case 'method': return 'Choose Delivery or Shipping to check out.';
      case 'area':
        return 'That ZIP is in our ' + m.switchToLabel + ' delivery area. Switch to ' + m.switchToLabel + ' delivery to check out.';
      case 'ship_checking':
        return 'One moment, checking shipping to ' + (m.shipState ? m.shipState.name : 'your state') + '.';
      case 'ship_blocked':
        return 'We can\'t ship these items to ' + m.shipState.name + '.';
      case 'zip':
        if (m && m.method === 'shipping') return 'Enter your ZIP code to check out.';
        if (S.zipResult && (S.zipResult.status === 'out_of_zone' || S.zipResult.status === 'other_metro')) {
          return 'We don\'t deliver to that ZIP yet. Choose Shipping to check out.';
        }
        return 'Enter your ZIP code to see delivery times.';
      case 'time': return 'Choose a delivery time to check out.';
      case 'slot':
        return m && !m.shippingAvailable
          ? 'No delivery times are open right now. Please check back soon.'
          : 'No delivery times are open right now. Choose Shipping or check back later.';
      case 'no_ship': return m.noShipMessage;
      default: return 'Finish choosing how you get your order to check out.';
    }
  }

  function nearestView(trigger) {
    var live = liveViews();
    if (!live.length) return null;
    if (!trigger) return live[0];
    var best = live[0];
    var bestDepth = -1;
    live.forEach(function (v) {
      var depth = 0;
      var a = v.el;
      while (a && !a.contains(trigger)) a = a.parentElement;
      for (var n = a; n; n = n.parentElement) depth++;
      if (a && depth > bestDepth && isShown(v.el)) { best = v; bestDepth = depth; }
    });
    return best;
  }

  function isShown(el) {
    if (!el.getClientRects) return true;
    if (typeof window.navigator === 'object' && /jsdom/i.test(window.navigator.userAgent || '')) return true;
    return el.getClientRects().length > 0;
  }

  function onGate(ev, trigger, retrigger) {
    if (S.bypass) return;
    if (isComplete()) {
      if (pendingForCheckout()) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        flush().then(function () {
          if (isComplete()) { S.bypass = true; try { retrigger(); } finally { S.bypass = false; } }
          else showBlocked(trigger);
        });
      }
      return;
    }
    ev.preventDefault();
    ev.stopImmediatePropagation();
    showBlocked(trigger);
  }

  /* ------------------------------------------- checkout button blocked state */

  var CHECKOUT_SEL = '[data-uq-checkout], a[href*="checkout"], button[name="checkout"], input[name="checkout"]';
  var FOREIGN_BLOCKERS = ['uq-stock-blocked', 'is-disabled']; // the theme's stock checks own these
  var reasonUid = 0;

  function checkoutButtons() {
    return Array.prototype.slice.call(document.querySelectorAll(CHECKOUT_SEL)).filter(function (el) {
      return checkoutTrigger(el) === el && !(el.closest && el.closest('[data-uqs-root]'));
    });
  }

  function reasonNodeFor(btn, create) {
    var id = btn.getAttribute('data-uqs-reason');
    var n = id ? document.getElementById(id) : null;
    if (n || !create) return n;
    id = 'uqs-coreason-' + (++reasonUid);
    n = document.createElement('p');
    n.className = 'uqs-checkout-reason';
    n.id = id;
    n.setAttribute('role', 'status');
    n.hidden = true;
    btn.setAttribute('data-uqs-reason', id);
    if (btn.parentNode) btn.parentNode.insertBefore(n, btn.nextSibling);
    return n;
  }

  function setDescribedBy(btn, id, on) {
    var cur = (btn.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    var has = cur.indexOf(id) >= 0;
    if (on === has) return;
    cur = on ? cur.concat(id) : cur.filter(function (x) { return x !== id; });
    if (cur.length) btn.setAttribute('aria-describedby', cur.join(' ')); else btn.removeAttribute('aria-describedby');
  }

  /**
   * Checkout buttons look and read as disabled while the order is incomplete, with the reason
   * shown under them. aria-disabled (not the disabled property) keeps the click, so the gate
   * can still scroll to and focus what is missing. Idempotent: called on every render and on
   * DOM changes (a re-rendered drawer brings fresh buttons).
   */
  function syncCheckoutButtons() {
    if (!S.started || !S.model) return;
    var blocked = !isComplete();
    var msg = blocked ? blockMessage(blockReason()) : '';
    checkoutButtons().forEach(function (btn) {
      var mine = btn.hasAttribute('data-uqs-blocked');
      if (blocked) {
        if (!mine) btn.setAttribute('data-uqs-blocked', '');
        if (!btn.classList.contains('uqs-checkout-blocked')) btn.classList.add('uqs-checkout-blocked');
        if (btn.getAttribute('aria-disabled') !== 'true') btn.setAttribute('aria-disabled', 'true');
      } else if (mine) {
        btn.removeAttribute('data-uqs-blocked');
        btn.classList.remove('uqs-checkout-blocked');
        var foreign = FOREIGN_BLOCKERS.some(function (c) { return btn.classList.contains(c); });
        if (!foreign) btn.removeAttribute('aria-disabled');
      }
      var n = reasonNodeFor(btn, blocked);
      if (!n) return;
      if (n.parentNode !== btn.parentNode || n.previousSibling !== btn) btn.parentNode.insertBefore(n, btn.nextSibling);
      if (n.textContent !== msg) n.textContent = msg;
      if (n.hidden !== !blocked) n.hidden = !blocked;
      setDescribedBy(btn, n.id, blocked);
    });
  }

  function showBlocked(trigger) {
    var reason = blockReason();
    var msg = blockMessage(reason);
    var v = nearestView(trigger);
    if (v) {
      setAlert(v, msg);
      try { v.el.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' }); } catch (e) { /* jsdom */ }
      var target = focusTargetFor(v, reason);
      if (target) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
    }
    dispatch('uforiq:schedule:blocked', { reason: reason, message: msg });
  }

  function focusTargetFor(v, reason) {
    var q = function (s) { return v.el.querySelector(s); };
    if (reason === 'method') return q('.uqs-methods [role="radio"]:not([aria-disabled="true"])');
    if (reason === 'area') return q('.uqs-zipmsg [data-uqs-action="area"]') || q('.uqs-zip-input');
    if (reason === 'ship_blocked') return q('.uqs-zip-input');
    if (reason === 'zip') {
      return S.zipResult && S.zipResult.status === 'out_of_zone' ? (q('[data-uqs-action="shipping"]') || q('.uqs-zip-input')) : q('.uqs-zip-input');
    }
    if (reason === 'time') return q('.uqs-slots [tabindex="0"]') || q('.uqs-days [tabindex="0"]');
    if (reason === 'slot') return q('.uqs-days [tabindex="0"]') || q('[data-uqs-action="shipping"]') || q('.uqs-methods [tabindex="0"]');
    if (reason === 'no_ship') return q('[data-uqs-action="noship-remove"]') || q('.uqs-noship');
    return q('.uqs-alert');
  }

  function installGate() {
    document.addEventListener('click', function (ev) {
      var t = checkoutTrigger(ev.target);
      if (!t) return;
      onGate(ev, t, function () { t.click(); });
    }, true);
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      var sub = ev.submitter || null;
      var isCheckout = (sub && (sub.name === 'checkout' || sub.hasAttribute('data-uq-checkout')));
      if (!isCheckout) {
        try {
          var action = new URL(form.getAttribute('action') || '', window.location.href);
          isCheckout = action.origin === window.location.origin && CHECKOUT_PATH.test(action.pathname);
        } catch (e) { isCheckout = false; }
      }
      if (!isCheckout) return;
      onGate(ev, sub || form, function () {
        if (sub && typeof form.requestSubmit === 'function') form.requestSubmit(sub);
        else {
          if (sub && sub.name) {
            var h = document.createElement('input');
            h.type = 'hidden'; h.name = sub.name; h.value = sub.value || '';
            form.appendChild(h);
          }
          form.submit();
        }
      });
    }, true);
  }

  /* -------------------------------------------------------------- announcing */

  function liveViews() {
    views = views.filter(function (v) { return v.el.isConnected !== false && document.documentElement.contains(v.el); });
    return views;
  }

  function primaryView() {
    var live = liveViews();
    for (var i = 0; i < live.length; i++) if (isShown(live[i].el)) return live[i];
    return live[0] || null;
  }

  function announce(text, kind) {
    var v = primaryView();
    if (!v) return;
    if (kind === 'alert') { setAlert(v, text); return; }
    var r = v.refs.status;
    r.textContent = '';
    setTimeout(function () { r.textContent = text; }, 30);
  }

  function setAlert(v, text) {
    liveViews().forEach(function (o) { if (o !== v) o.refs.alert.textContent = ''; });
    var r = v.refs.alert;
    r.textContent = '';
    r.hidden = !text;
    setTimeout(function () { r.textContent = text; r.hidden = !text; }, 30);
  }

  function clearAlerts() {
    liveViews().forEach(function (v) { v.refs.alert.textContent = ''; v.refs.alert.hidden = true; });
  }

  /* ----------------------------------------------------------------- actions */

  function chooseMethod(method) {
    if (method === 'delivery' && !(S.model && S.model.deliveryAvailable)) return;
    if (method === 'shipping' && S.model && !S.model.shippingAvailable) return;
    if (S.model && S.model.method === method) return;
    S.method = method;
    S.methodExplicit = true;
    S.autoShipZip = null;
    S.awaitTime = false;
    store.write({ method: method });
    if (method === 'shipping') S.selection = { slotId: null, priority: false, dayKey: null };
    clearAlerts();
    recompute('select');
    var eff = S.model && S.model.method;
    announce(eff === 'shipping' && S.autoShipZip
      ? 'We don\'t deliver to ' + S.autoShipZip + ' yet, so this order will ship.'
      : (eff === 'shipping' ? 'Shipping selected.' : 'Delivery selected.'));
    if (method === 'delivery' && S.zip && !S.zipResult) resolveCurrentZip().then(function () { recompute('zip'); });
  }

  function chooseDay(dayKey) {
    var m = S.model;
    if (!m || !m.days.length) return;
    var day = m.days.filter(function (d) { return d.dateKey === dayKey; })[0];
    if (!day || !day.available) return;
    if (m.slot && m.slot.dateKey === dayKey) {
      S.selection.dayKey = dayKey;
      recompute('select');
      return;
    }
    var hadPriority = S.selection.priority;
    if (S.awaitTime && !S.selection.slotId) {
      // the shopper has not picked a time yet: show this day's times, pick none
      S.selection = { slotId: null, priority: false, dayKey: dayKey };
      clearAlerts();
      recompute('select');
      announce(day.label + ' selected. Choose a delivery time.');
      return;
    }
    var first = day.slots.filter(function (s) { return s.available; })[0];
    S.selection = { slotId: first ? first.id : null, priority: false, dayKey: dayKey };
    clearAlerts();
    recompute('select');
    if (first) announce(day.label + ', ' + first.label + ' selected.' + (hadPriority ? ' Priority removed.' : ''));
  }

  function chooseSlot(slotId) {
    var m = S.model;
    var slot = m && E.findSlot(m.days, slotId);
    if (!slot || !slot.available) return;
    var hadPriority = S.selection.priority;
    S.awaitTime = false;
    S.selection = { slotId: slotId, priority: false, dayKey: slot.dateKey };
    clearAlerts();
    recompute('select');
    announce(slot.label + ' selected.' + (hadPriority ? ' Priority removed.' : ''));
  }

  function choosePriority() {
    var m = S.model;
    if (!m || !m.priorityAvailable || !m.earliest) return;
    S.awaitTime = false;
    S.selection = { slotId: m.earliest.id, priority: true, dayKey: m.earliest.dateKey };
    clearAlerts();
    recompute('select');
    announce('Priority selected: guaranteed ' + dayWord(m.earliest.dateKey) + ', ' + m.earliest.label + '.');
  }

  function submitZip(value) {
    var digits = String(value || '').replace(/\D/g, '').slice(0, 5);
    S.zip = digits;
    if (E.normalizeZip(digits)) store.write({ zip: digits });
    var prevZone = S.zipResult && S.zipResult.zone && S.zipResult.zone.id;
    var wasShipping = !!(S.model && S.model.method === 'shipping');
    if (S.autoShipZip && S.autoShipZip !== E.normalizeZip(digits)) S.autoShipZip = null;
    clearAlerts();
    renderAll();
    return resolveCurrentZip().then(function () {
      var r = S.zipResult;
      if (!r || !r.zone || r.zone.id !== prevZone) S.selection = { slotId: null, priority: S.selection.priority, dayKey: null };
      // Shipping, then a delivery ZIP: Delivery takes over, but the shopper picks the time.
      if (wasShipping && r && (r.status === 'ok' || r.status === 'other_metro')) {
        S.awaitTime = true;
        S.selection = { slotId: null, priority: false, dayKey: null };
      }
      recompute('zip');
      if (r && r.status === 'other_metro' && S.model && S.model.switchTo && switchArea(S.model.switchTo)) return;
      if (r && r.status === 'ok') announce('Good news, we deliver to ' + r.zip + '.' + (S.model && S.model.blockReason === 'time' ? ' Choose a delivery time.' : ''));
      else if (r && r.status === 'out_of_zone' && S.model && S.model.method === 'shipping') { /* autoShip announced it */ }
      else if (r && r.status === 'out_of_zone') announce('We don\'t deliver to that ZIP yet. Shipping is available.');
      else if (r && r.status === 'invalid') announce('Enter a 5-digit ZIP code.');
    });
  }

  /**
   * Move the site area to a delivery metro through the location picker's public API
   * (window.UforiqLocation.set, which saves the area and fires uforiq:location:changed;
   * the cart drawer then writes the Delivery-Area cart attribute). Without set(), opens the
   * picker when it can. Returns true when the area was switched.
   */
  function switchArea(metro) {
    var loc = window.UforiqLocation;
    if (loc && typeof loc.set === 'function') {
      S.switchNotice = metro;
      loc.set(metro);
      var label = (S.config.metros[metro] && S.config.metros[metro].label) || metro;
      announce('Good news: you\'re in our ' + label + ' delivery area, so this order goes out by local delivery.');
      return true;
    }
    if (loc && typeof loc.open === 'function') { try { loc.open(); } catch (e) { /* ignore */ } }
    return false;
  }

  /** Keep the saved instructions in this browser in step with the box (only while Save is on). */
  function rememberNote() {
    if (!S.saveNote) return;
    var n = E.cleanNote(S.note);
    if (n) ls.set(NOTE_KEY, n); else ls.remove(NOTE_KEY);
  }

  function setSaveNote(on) {
    S.saveNote = !!on;
    ls.set(SAVE_KEY, S.saveNote ? '1' : '0');
    if (S.saveNote) rememberNote(); else ls.remove(NOTE_KEY);
    liveViews().forEach(function (o) { o.refs.save.checked = S.saveNote; });
    recompute('note');
  }

  function onLocationChanged(next) {
    var area = next ? String(next).toLowerCase() : null;
    if (area === S.area) return;
    var wasMetro = S.model && S.model.metro;
    S.area = area;
    if (S.switchNotice !== area) S.switchNotice = null;
    S.selection = { slotId: null, priority: false, dayKey: null };
    S.pin = null;
    closePinDialog(false);
    var isMetro = !!(area && S.config && S.config.zones.some(function (z) { return z.metro === area; }));
    if (!isMetro && S.method === 'delivery') { S.method = null; S.methodExplicit = false; }
    if (isMetro && !S.methodExplicit) S.method = null;
    if (wasMetro !== area) S.zipResult = null;
    clearAlerts();
    var p = S.zip ? resolveCurrentZip() : Promise.resolve();
    recompute('area');
    p.then(function () { recompute('area'); });
  }

  function revalidate(reason) {
    if (!S.started) return;
    recompute(reason || 'tick');
  }

  /* ------------------------------------------------------------------- views */

  var ICONS = {
    truck: '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6.5h11v9H2z"/><path d="M13 9.5h4.2l3.3 3.4v2.6H13z"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    box: '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5 12 12l8.5-4.5M12 12v9"/></svg>',
    check: '<svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="m3.5 8.4 2.9 2.9 6.1-6.6"/></svg>',
    bolt: '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M13.2 2 4.8 13.1h5.6L9.6 22l8.6-11.6h-5.7z"/></svg>',
    pin: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.3"/></svg>',
    left: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m14.5 6-6 6 6 6"/></svg>',
    locate: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3.2"/><circle cx="12" cy="12" r="7.5"/><path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22"/></svg>',
    close: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    right: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m9.5 6 6 6-6 6"/></svg>'
  };

  function skeleton(id) {
    return '' +
      '<div class="uqs-inner">' +
        '<h2 class="uqs-title" id="' + id + '-title">How do you want your order?</h2>' +
        '<div class="uqs-methods" role="radiogroup" aria-labelledby="' + id + '-title" data-uqs-region="methods"></div>' +
        '<p class="uqs-inzone" data-uqs-region="inzone" hidden></p>' +
        '<div class="uqs-areahint" data-uqs-region="areahint" hidden></div>' +
        '<div class="uqs-panel uqs-panel--zip" data-uqs-zipbox hidden>' +
          '<form class="uqs-zip" novalidate>' +
            '<label class="uqs-label" for="' + id + '-zip" data-uqs-ziplabel>Delivery ZIP code</label>' +
            '<div class="uqs-zip-row">' +
              '<span class="uqs-zip-ico" aria-hidden="true">' + ICONS.pin + '</span>' +
              '<input class="uqs-zip-input" id="' + id + '-zip" name="uqs-zip" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="5" autocomplete="postal-code" aria-describedby="' + id + '-zipmsg">' +
              '<button class="uqs-btn uqs-btn--ghost" type="submit">Check</button>' +
            '</div>' +
          '</form>' +
          '<div class="uqs-zipmsg" id="' + id + '-zipmsg" data-uqs-region="zipmsg"></div>' +
        '</div>' +
        '<div class="uqs-panel uqs-panel--delivery" data-uqs-region="delivery" hidden>' +
          '<div class="uqs-sched" data-uqs-region="sched" hidden>' +
            '<div class="uqs-subrow">' +
              '<div class="uqs-subhead" id="' + id + '-days">Choose a day</div>' +
              '<div class="uqs-arrows" aria-hidden="true">' +
                '<button class="uqs-scrollbtn" type="button" tabindex="-1" data-uqs-scroll="-1">' + ICONS.left + '</button>' +
                '<button class="uqs-scrollbtn" type="button" tabindex="-1" data-uqs-scroll="1">' + ICONS.right + '</button>' +
              '</div>' +
            '</div>' +
            '<div class="uqs-scroller">' +
              '<div class="uqs-row uqs-days" role="radiogroup" aria-labelledby="' + id + '-days" data-uqs-region="days"></div>' +
            '</div>' +
            '<div class="uqs-subrow">' +
              '<div class="uqs-subhead" id="' + id + '-slots">Choose a time</div>' +
              '<div class="uqs-arrows" aria-hidden="true">' +
                '<button class="uqs-scrollbtn" type="button" tabindex="-1" data-uqs-scroll="-1">' + ICONS.left + '</button>' +
                '<button class="uqs-scrollbtn" type="button" tabindex="-1" data-uqs-scroll="1">' + ICONS.right + '</button>' +
              '</div>' +
            '</div>' +
            '<div class="uqs-scroller">' +
              '<div class="uqs-row uqs-slots" role="radiogroup" aria-labelledby="' + id + '-slots" data-uqs-region="slots"></div>' +
            '</div>' +
            '<p class="uqs-feenote" data-uqs-region="feenote"></p>' +
          '</div>' +
          '<div class="uqs-note">' +
            '<label class="uqs-label" for="' + id + '-note">Delivery instructions <span class="uqs-opt">(optional)</span></label>' +
            '<textarea class="uqs-note-input" id="' + id + '-note" rows="2" maxlength="' + E.NOTE_MAX + '" aria-describedby="' + id + '-notecount" placeholder="Gate code, apartment number, parking. We cannot leave orders on your porch."></textarea>' +
            '<div class="uqs-note-foot">' +
              '<label class="uqs-check"><input class="uqs-save-input" type="checkbox" checked> <span>Save for future orders</span></label>' +
              '<div class="uqs-count" id="' + id + '-notecount" data-uqs-region="notecount"></div>' +
            '</div>' +
          '</div>' +
          '<div class="uqs-pin" data-uqs-region="pin" hidden></div>' +
        '</div>' +
        '<div class="uqs-panel uqs-panel--shipping" data-uqs-region="shipping" hidden></div>' +
        '<div class="uqs-noship" tabindex="-1" data-uqs-region="noship" hidden></div>' +
        '<div class="uqs-alert" role="alert" data-uqs-region="alert" hidden></div>' +
        '<div class="uqs-vh" aria-live="polite" aria-atomic="true" data-uqs-region="status"></div>' +
      '</div>';
  }

  function createView(el, context) {
    var id = 'uqs' + (++uid);
    el.__uqsView = true;
    el.classList.add('uqs');
    el.classList.toggle('uqs--drawer', context === 'drawer');
    el.setAttribute('data-uqs-mounted', VERSION);
    // keep the config/priority/fee JSON scripts, replace the rest
    Array.prototype.slice.call(el.children).forEach(function (c) {
      if (!(c.tagName === 'SCRIPT' && c.type === 'application/json')) el.removeChild(c);
    });
    var wrap = document.createElement('div');
    wrap.innerHTML = skeleton(id);
    el.appendChild(wrap.firstChild);
    var refs = {};
    Array.prototype.slice.call(el.querySelectorAll('[data-uqs-region]')).forEach(function (n) {
      refs[n.getAttribute('data-uqs-region')] = n;
    });
    refs.zipInput = el.querySelector('.uqs-zip-input');
    refs.zipForm = el.querySelector('.uqs-zip');
    refs.zipBox = el.querySelector('[data-uqs-zipbox]');
    refs.zipLabel = el.querySelector('[data-uqs-ziplabel]');
    refs.note = el.querySelector('.uqs-note-input');
    refs.save = el.querySelector('.uqs-save-input');
    var v = { id: id, el: el, context: context, refs: refs, sig: {} };
    bindView(v);
    return v;
  }

  function bindView(v) {
    var el = v.el;
    el.addEventListener('click', function (ev) {
      var t = ev.target.closest('[role="radio"], [data-uqs-action], [data-uqs-scroll]');
      if (!t || !el.contains(t)) return;
      if (t.hasAttribute('data-uqs-scroll')) {
        var row = t.closest('.uqs-subrow').nextElementSibling.querySelector('.uqs-row');
        row.scrollBy({ left: Number(t.getAttribute('data-uqs-scroll')) * row.clientWidth * 0.8, behavior: reducedMotion() ? 'auto' : 'smooth' });
        return;
      }
      if (t.hasAttribute('data-uqs-action')) { runAction(t.getAttribute('data-uqs-action'), t.getAttribute('data-value'), v, t); return; }
      activateRadio(v, t);
    });
    el.addEventListener('keydown', function (ev) {
      var t = ev.target;
      if (!t || t.getAttribute('role') !== 'radio') return;
      var group = t.closest('[role="radiogroup"]');
      var items = Array.prototype.slice.call(group.querySelectorAll('[role="radio"]'))
        .filter(function (n) { return n.getAttribute('aria-disabled') !== 'true'; });
      var i = items.indexOf(t);
      var next = null;
      switch (ev.key) {
        case 'ArrowRight': case 'ArrowDown': next = items[(i + 1) % items.length]; break;
        case 'ArrowLeft': case 'ArrowUp': next = items[(i - 1 + items.length) % items.length]; break;
        case 'Home': next = items[0]; break;
        case 'End': next = items[items.length - 1]; break;
        case ' ': case 'Enter': ev.preventDefault(); activateRadio(v, t); return;
        default: return;
      }
      ev.preventDefault();
      if (next) { v.focusKey = next.getAttribute('data-key'); activateRadio(v, next); focusKey(v); }
    });
    v.refs.zipForm.addEventListener('submit', function (ev) {
      ev.preventDefault();
      submitZip(v.refs.zipInput.value);
    });
    v.refs.zipInput.addEventListener('input', function () {
      var digits = v.refs.zipInput.value.replace(/\D/g, '').slice(0, 5);
      if (digits !== v.refs.zipInput.value) v.refs.zipInput.value = digits;
      if (digits.length === 5 && digits !== (S.zipResult && S.zipResult.zip)) submitZip(digits);
    });
    // Saved instructions are selected on the first click, so typing replaces them instead of
    // adding to the end; a second click places the cursor to edit them.
    v.refs.note.addEventListener('focus', function () {
      if (!S.notePrefilled || !v.refs.note.value) return;
      S.notePrefilled = false;
      v.refs.note.select();
      v.keepNoteSelection = true;
    });
    // the click that focused the box would otherwise drop the selection on mouseup
    v.refs.note.addEventListener('mouseup', function (ev) {
      if (v.keepNoteSelection) ev.preventDefault();
      v.keepNoteSelection = false;
    });
    v.refs.note.addEventListener('input', function () {
      S.notePrefilled = false;
      S.note = v.refs.note.value.slice(0, E.NOTE_MAX);
      liveViews().forEach(function (o) { if (o !== v) o.refs.note.value = S.note; });
      // the shopper edited this cart's note: do not prefill it again for this cart
      if (S.cart && S.cart.token) store.write({ noteCart: S.cart.token });
      rememberNote();
      recompute('note');
    });
    v.refs.save.addEventListener('change', function () {
      setSaveNote(v.refs.save.checked);
    });
    Array.prototype.slice.call(el.querySelectorAll('.uqs-row')).forEach(function (row) {
      row.addEventListener('scroll', function () { updateScrollEdges(row); }, { passive: true });
    });
  }

  function runAction(action, value, v, t) {
    if (action === 'shipping') chooseMethod('shipping');
    else if (action === 'delivery') chooseMethod('delivery');
    else if (action === 'noship-remove') removeNoShip();
    else if (action === 'pin-open') openPinDialog(v, t);
    else if (action === 'pin-remove') removePin(v);
    else if (action === 'area') switchArea(value);
    else if (action === 'zip-focus') { try { v.refs.zipInput.focus(); v.refs.zipInput.select(); } catch (e) { /* ignore */ } }
  }

  function activateRadio(v, t) {
    if (t.getAttribute('aria-disabled') === 'true') return;
    var key = t.getAttribute('data-key') || '';
    v.focusKey = key;
    if (key.indexOf('m:') === 0) chooseMethod(key.slice(2));
    else if (key.indexOf('d:') === 0) chooseDay(key.slice(2));
    else if (key.indexOf('s:') === 0) chooseSlot(key.slice(2));
    else if (key === 'p') choosePriority();
    focusKey(v);
  }

  function focusKey(v) {
    if (!v.focusKey) return;
    var n = v.el.querySelector('[data-key="' + v.focusKey + '"]');
    if (n && document.activeElement !== n) { try { n.focus({ preventScroll: true }); } catch (e) { n.focus(); } }
    if (n && n.scrollIntoView && n.closest('.uqs-row')) {
      try { n.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reducedMotion() ? 'auto' : 'smooth' }); } catch (e) { /* old engines */ }
    }
  }

  function updateScrollEdges(row) {
    var sc = row.parentNode;
    var sub = sc.previousElementSibling;
    var max = row.scrollWidth - row.clientWidth;
    var canPrev = row.scrollLeft > 4;
    var canNext = max - row.scrollLeft > 4;
    sc.classList.toggle('uqs-can-prev', canPrev);
    sc.classList.toggle('uqs-can-next', canNext);
    if (sub && sub.classList.contains('uqs-subrow')) {
      sub.classList.toggle('uqs-overflow', max > 4);
      var b = sub.querySelectorAll('[data-uqs-scroll]');
      if (b.length === 2) { b[0].disabled = !canPrev; b[1].disabled = !canNext; }
    }
  }

  /* ---------------------------------------------------------------- rendering */

  function radio(key, checked, disabled, cls, inner, extra) {
    return '<div class="' + cls + '" role="radio" data-key="' + esc(key) + '" aria-checked="' + (checked ? 'true' : 'false') + '"' +
      (disabled ? ' aria-disabled="true"' : '') + (extra || '') + ' tabindex="-1">' +
      '<span class="uqs-tick" aria-hidden="true">' + ICONS.check + '</span>' + inner + '</div>';
  }

  /** Roving tabindex: the checked enabled radio (or first enabled) gets tabindex 0. */
  function rove(group) {
    var items = Array.prototype.slice.call(group.querySelectorAll('[role="radio"]'));
    var enabled = items.filter(function (n) { return n.getAttribute('aria-disabled') !== 'true'; });
    var target = enabled.filter(function (n) { return n.getAttribute('aria-checked') === 'true'; })[0] || enabled[0];
    items.forEach(function (n) { n.setAttribute('tabindex', n === target ? '0' : '-1'); });
  }

  function setRegion(v, name, html) {
    if (v.sig[name] === html) return false;
    v.sig[name] = html;
    var r = v.refs[name];
    var row = r.classList.contains('uqs-row') ? r : null;
    var left = row ? row.scrollLeft : 0;
    r.innerHTML = html;
    if (r.getAttribute('role') === 'radiogroup') rove(r);
    if (row) { row.scrollLeft = left; updateScrollEdges(row); }
    return true;
  }

  function show(node, on) { node.hidden = !on; }

  function feeHtml(fee, srPrefix) {
    if (!fee) return '';
    if (fee.reduced) {
      return '<span class="uqs-fee"><s class="uqs-was" aria-hidden="true">' + E.formatMoney(fee.baseCents) + '</s> ' +
        '<span class="uqs-free" aria-hidden="true">' + (fee.free ? 'Free' : E.formatMoney(fee.cents)) + '</span>' +
        '<span class="uqs-vh">' + esc(srPrefix) + (fee.free ? 'free' : E.formatMoney(fee.cents)) + ', was ' + E.formatMoney(fee.baseCents) + '</span></span>';
    }
    return '<span class="uqs-fee"><span aria-hidden="true">' + (fee.free ? 'Free' : E.formatMoney(fee.cents)) + '</span>' +
      '<span class="uqs-vh">' + esc(srPrefix) + (fee.free ? 'free' : E.formatMoney(fee.cents)) + '</span></span>';
  }

  function minFeeForMetro(metro, subtotal) {
    var zones = E.zonesForMetro(S.config, metro);
    if (!zones.length) return null;
    return E.deliveryFee(S.config, zones[0], subtotal);
  }

  function renderMethods(v, m) {
    var c = S.config;
    var dSub;
    var dDisabled = !m.deliveryAvailable;
    if (dDisabled) dSub = 'Choose Austin or Lubbock for same-day delivery';
    else {
      var f = m.fee || minFeeForMetro(m.metro, m.subtotalCents);
      dSub = esc(m.metroLabel) + ' area' + '<br>' + (f && f.free ? 'Free delivery' : 'Free on ' + E.formatMoney(E.toCents(c.freeDeliveryThreshold), { trim: true }) + '+');
    }
    var shipFree = m.freeShippingRemainingCents === 0;
    var sSub = 'Nationwide<br>' + (shipFree ? 'Free shipping' : 'Free on ' + E.formatMoney(E.toCents(c.freeShippingThreshold), { trim: true }) + '+');
    var html =
      radio('m:delivery', m.method === 'delivery', dDisabled, 'uqs-card uqs-method' + (dDisabled ? ' is-disabled' : ''),
        '<span class="uqs-ico" aria-hidden="true">' + ICONS.truck + '</span> ' +
        '<span class="uqs-card-title">Delivery</span> <span class="uqs-card-sub">' + dSub + '</span>') +
      (m.shippingAvailable ? radio('m:shipping', m.method === 'shipping', false, 'uqs-card uqs-method',
        '<span class="uqs-ico" aria-hidden="true">' + ICONS.box + '</span> ' +
        '<span class="uqs-card-title">Shipping</span> <span class="uqs-card-sub">' + sSub + '</span>') : '');
    setRegion(v, 'methods', html);
    v.refs.methods.classList.toggle('is-single', !m.shippingAvailable);
    // ZIP in another delivery area: the switch box under the ZIP field is the only choice.
    show(v.refs.methods, !m.switchTo);
    // In zone: Shipping is not offered, so say why instead of showing the card.
    var inzone = !m.shippingAvailable && !m.switchTo;
    var zipOk = S.zipResult && S.zipResult.status === 'ok';
    show(v.refs.inzone, inzone);
    setRegion(v, 'inzone', !inzone ? '' : (zipOk && S.switchNotice && S.switchNotice === m.metro
      ? 'Good news: you\'re in our ' + esc(m.metroLabel) + ' delivery area, so this order goes out by local delivery.'
      : zipOk
        ? 'You\'re in our delivery area, so orders here go out by local delivery.'
        : 'Orders in the ' + esc(m.metroLabel) + ' area go out by local delivery.'));
  }

  function renderAreaHint(v, m) {
    var canSet = !!(window.UforiqLocation && typeof window.UforiqLocation.set === 'function');
    var on = !m.deliveryAvailable && canSet && !m.switchTo;
    show(v.refs.areahint, on);
    if (!on) return setRegion(v, 'areahint', '');
    var metros = Object.keys(S.config.metros).filter(function (k) { return S.config.zones.some(function (z) { return z.metro === k; }); });
    setRegion(v, 'areahint',
      '<span class="uqs-areahint-text">In ' + metros.map(function (k) { return esc(S.config.metros[k].label || k); }).join(' or ') + '? Switch your area for delivery:</span>' +
      '<span class="uqs-areahint-btns">' + metros.map(function (k) {
        return '<button type="button" class="uqs-btn uqs-btn--chip" data-uqs-action="area" data-value="' + esc(k) + '">' + esc(S.config.metros[k].label || k) + '</button>';
      }).join('') + '</span>');
  }

  function renderZipMsg(v, m) {
    var r = S.zipResult;
    var html = '';
    if (m.switchTo) html = switchBoxHtml(m);
    else if (m.method === 'shipping') {
      html = (S.autoShipZip && S.autoShipZip === m.zipValue
        ? '<p class="uqs-msg uqs-msg--warn uqs-autoship">We don\'t deliver to ' + esc(S.autoShipZip) + ' yet, so this order will ship.</p>'
        : '') + shipZipMsgHtml(m);
    } else if (S.zipStatus === 'loading') html = '<p class="uqs-msg uqs-msg--muted">Checking your ZIP...</p>';
    else if (S.zipStatus === 'unavailable') html = '<p class="uqs-msg uqs-msg--error">We couldn\'t check that ZIP right now. Please try again.</p>';
    else if (!r) html = '<p class="uqs-msg uqs-msg--muted">' + (m.method === 'delivery' ? 'Enter your ZIP to see delivery times.' : 'Enter your ZIP to see your options.') + '</p>';
    else if (r.status === 'invalid') html = '<p class="uqs-msg uqs-msg--error">Enter a 5-digit ZIP code.</p>';
    else if (r.status === 'ok') {
      html = '<p class="uqs-msg uqs-msg--ok"><span class="uqs-okdot" aria-hidden="true">' + ICONS.check + '</span>' +
        'We deliver to ' + esc(r.zip) + ' in the ' + esc(m.metroLabel) + ' area.</p>';
    } else if (r.status === 'other_metro') {
      var other = S.config.metros[r.otherMetro] ? S.config.metros[r.otherMetro].label : r.otherMetro;
      var canSet = !!(window.UforiqLocation && typeof window.UforiqLocation.set === 'function');
      html = '<div class="uqs-oz"><p class="uqs-msg uqs-msg--warn">That ZIP is in our ' + esc(other) + ' delivery area.</p>' +
        '<div class="uqs-oz-btns">' +
        (canSet ? '<button type="button" class="uqs-btn uqs-btn--primary" data-uqs-action="area" data-value="' + esc(r.otherMetro) + '">Switch to ' + esc(other) + '</button>' : '') +
        '<button type="button" class="uqs-btn uqs-btn--ghost" data-uqs-action="shipping">Switch to Shipping</button></div></div>';
    } else {
      html = '<div class="uqs-oz"><p class="uqs-msg uqs-msg--warn">We don\'t deliver to that ZIP yet. Shipping is available.</p>' +
        '<div class="uqs-oz-btns"><button type="button" class="uqs-btn uqs-btn--primary" data-uqs-action="shipping">Switch to Shipping</button></div></div>';
    }
    setRegion(v, 'zipmsg', html);
  }

  /** ZIP inside another delivery area: say so, and switch the site area on one tap. */
  function switchBoxHtml(m) {
    var loc = window.UforiqLocation;
    var canSwitch = !!(loc && (typeof loc.set === 'function' || typeof loc.open === 'function'));
    var label = esc(m.switchToLabel);
    return '<div class="uqs-oz uqs-oz--switch"><p class="uqs-msg">Good news: ' + esc(m.zipValue || '') +
      ' is in our ' + label + ' delivery area, so this order goes out by local delivery.</p>' +
      (canSwitch
        ? '<div class="uqs-oz-btns"><button type="button" class="uqs-btn uqs-btn--primary" data-uqs-action="area" data-value="' +
          esc(m.switchTo) + '">Switch to ' + label + ' delivery</button>' +
          '<button type="button" class="uqs-btn uqs-btn--ghost" data-uqs-action="zip-focus">Use a different ZIP</button></div>'
        : '<p class="uqs-msg uqs-msg--muted">Choose ' + label + ' in the area menu at the top of the page to see delivery times.</p>') +
      '</div>';
  }

  /** Shipping: the ZIP is required and the cart must be shippable to its state. */
  function shipZipMsgHtml(m) {
    var r = S.zipResult;
    var st = m.shipState;
    if (!m.zipValue) {
      return S.zip
        ? '<p class="uqs-msg uqs-msg--error">Enter a 5-digit ZIP code.</p>'
        : '<p class="uqs-msg uqs-msg--muted">Enter your ZIP so we can check shipping to your state.</p>';
    }
    if (r && r.status === 'invalid') return '<p class="uqs-msg uqs-msg--error">Enter a 5-digit ZIP code.</p>';
    if (S.zipStatus === 'loading') return '<p class="uqs-msg uqs-msg--muted">Checking your ZIP...</p>';
    if (!st) return '';
    var name = esc(st.name);
    if (m.shipCheck === 'none') {
      return '<div class="uqs-oz uqs-oz--stop"><p class="uqs-msg uqs-msg--error">We can\'t ship these items to ' + name + '.</p>' +
        '<p class="uqs-msg">Some items have state limits. Remove them or try a different ZIP.</p></div>';
    }
    if (m.shipCheck === 'pending') return '<p class="uqs-msg uqs-msg--muted">Checking shipping to ' + name + '...</p>';
    if (m.shipCheck === 'ok') {
      return '<p class="uqs-msg uqs-msg--ok"><span class="uqs-okdot" aria-hidden="true">' + ICONS.check + '</span>' +
        'Good news, we ship to ' + name + '.</p>';
    }
    if (m.shipCheck === 'error') return '<p class="uqs-msg uqs-msg--muted">Shipping to ' + name + '.</p>';
    // below config.shipCheckMinCents (0 by default since the $20 minimum went away): no check yet
    if (m.subtotalCents < S.config.shipCheckMinCents) {
      return '<p class="uqs-msg uqs-msg--muted">We\'ll check shipping to ' + name + ' once your order reaches ' +
        E.formatMoney(S.config.shipCheckMinCents, { trim: true }) + '.</p>';
    }
    return '';
  }

  function renderSchedule(v, m) {
    var on = !!m.zone;
    show(v.refs.sched, on);
    if (!on) { setRegion(v, 'days', ''); setRegion(v, 'slots', ''); setRegion(v, 'feenote', ''); return; }

    var days = m.days.map(function (d) {
      var sub = d.available ? d.shortDate : 'Closed';
      return radio('d:' + d.dateKey, d.dateKey === m.dayKey, !d.available, 'uqs-chip' + (d.available ? '' : ' is-disabled'),
        '<span class="uqs-chip-top">' + esc(d.label) + '</span> <span class="uqs-chip-sub">' + esc(sub) + '</span>',
        d.available ? '' : ' aria-label="' + esc(d.label + ', ' + d.shortDate + ', no times available') + '"');
    }).join('');
    setRegion(v, 'days', days || '<p class="uqs-msg uqs-msg--muted">No delivery days are open.</p>');

    var day = m.days.filter(function (d) { return d.dateKey === m.dayKey; })[0];
    var html = '';
    var pr = S.config.priority;
    if (m.priorityAvailable && m.earliest && day && day.dateKey === m.earliest.dateKey) {
      html += radio('p', m.priority, S.busy, 'uqs-card uqs-slot uqs-priority' + (S.busy && m.priority ? ' is-busy' : ''),
        '<span class="uqs-pri-badge" aria-hidden="true">' + ICONS.bolt + '</span> ' +
        '<span class="uqs-slot-time">Priority</span> ' +
        '<span class="uqs-slot-meta">Guaranteed time slot</span> ' +
        '<span class="uqs-slot-meta uqs-pri-when">' + esc(m.earliest.label) + '</span> ' +
        '<span class="uqs-fee uqs-fee--add">+' + E.formatMoney(E.toCents(pr.price)) + '</span>');
    }
    // Only open slots are shown; past or full ones are left out so the first card is the next available time.
    (day ? day.slots : []).filter(function (s) { return s.available; }).forEach(function (s) {
      var checked = !m.priority && m.slot && m.slot.id === s.id;
      html += radio('s:' + s.id, checked, false, 'uqs-card uqs-slot',
        '<span class="uqs-slot-time">' + esc(s.label) + '</span>' +
        ' <span class="uqs-slot-meta">Delivery fee</span> ' + feeHtml(m.fee, 'Delivery fee '));
    });
    if (day && !day.available) html += '<p class="uqs-msg uqs-msg--muted">No times left on this day.</p>';
    setRegion(v, 'slots', html);

    var note;
    if (!m.slot && m.earliest) {
      note = 'Choose a delivery time to check out.';
    } else if (!m.slot) {
      note = m.shippingAvailable
        ? 'No delivery times are open right now. Shipping is always available.'
        : 'No delivery times are open right now. Please check back soon.';
    } else if (m.freeDeliveryRemainingCents === 0) {
      note = 'You get free delivery on this order.';
    } else {
      note = 'Free delivery on orders ' + E.formatMoney(E.toCents(S.config.freeDeliveryThreshold), { trim: true }) +
        '+. Add ' + E.formatMoney(m.freeDeliveryRemainingCents) + ' to unlock it.';
    }
    setRegion(v, 'feenote', esc(note) + (m.slot || m.earliest || !m.shippingAvailable ? '' : ' <button type="button" class="uqs-linkbtn" data-uqs-action="shipping">Switch to Shipping</button>'));
  }

  function renderShipping(v, m) {
    var c = S.config;
    var rem = m.freeShippingRemainingCents;
    var pct = Math.min(100, Math.round((m.subtotalCents / E.toCents(c.freeShippingThreshold)) * 100));
    var html = '<p class="uqs-ship-lead">Ships to most US states. Choose a shipping option at checkout.</p>' +
      '<div class="uqs-progress" aria-hidden="true"><span style="width:' + pct + '%"></span></div>' +
      '<p class="uqs-msg ' + (rem ? 'uqs-msg--muted' : 'uqs-msg--ok') + '">' +
      (rem ? 'Free shipping on orders ' + E.formatMoney(E.toCents(c.freeShippingThreshold), { trim: true }) + '+. Add ' + E.formatMoney(rem) + ' to unlock it.'
        : 'You get free shipping on this order.') + '</p>';
    setRegion(v, 'shipping', html);
  }

  function renderView(v) {
    var m = S.model;
    if (!m) return;
    v.el.classList.toggle('uqs--busy', S.busy);
    v.el.classList.toggle('uqs--empty', m.itemCount === 0);
    renderMethods(v, m);
    renderAreaHint(v, m);
    var isD = m.method === 'delivery';
    show(v.refs.delivery, isD);
    show(v.refs.shipping, m.method === 'shipping');
    // ZIP field: every cart (Delivery, Shipping, or no area yet), unless config.requireZip is off for Shipping.
    var zipOn = !(m.method === 'shipping' && !S.config.requireZip);
    show(v.refs.zipBox, zipOn);
    if (zipOn) {
      var zl = isD ? 'Delivery ZIP code' : (m.method === 'shipping' ? 'Shipping ZIP code' : 'Your ZIP code');
      if (v.refs.zipLabel.textContent !== zl) v.refs.zipLabel.textContent = zl;
      if (document.activeElement !== v.refs.zipInput && v.refs.zipInput.value !== S.zip) v.refs.zipInput.value = S.zip;
      renderZipMsg(v, m);
    }
    if (isD) {
      if (document.activeElement !== v.refs.note && v.refs.note.value !== S.note) v.refs.note.value = S.note;
      v.refs.notecount.textContent = (S.note || '').length + ' / ' + E.NOTE_MAX;
      if (v.refs.save.checked !== S.saveNote) v.refs.save.checked = S.saveNote;
      renderPin(v, m);
      renderSchedule(v, m);
    }
    if (m.method === 'shipping') renderShipping(v, m);
    var ns = m.method === 'shipping' && m.noShipLines.length > 0;
    show(v.refs.noship, ns);
    setRegion(v, 'noship', ns
      ? '<p class="uqs-noship-msg"><strong>' + esc(m.noShipMessage) + '</strong></p>' +
        '<div class="uqs-oz-btns"><button type="button" class="uqs-btn uqs-btn--primary" data-uqs-action="noship-remove">' +
          (m.noShipLines.length === 1 ? 'Remove ' + esc(m.noShipLines[0].product_title || 'item') : 'Remove these items') + '</button>' +
        (m.noShipCanDeliver ? '<button type="button" class="uqs-btn uqs-btn--ghost" data-uqs-action="delivery">Choose Delivery</button>' : '') +
        '</div>'
      : '');
  }

  function renderAll() {
    syncCheckoutButtons();
    liveViews().forEach(function (v) {
      var ae = document.activeElement;
      var key = ae && v.el.contains(ae) && ae.getAttribute ? ae.getAttribute('data-key') : null;
      renderView(v);
      if (key) {
        var n = v.el.querySelector('[data-key="' + key + '"]');
        if (n && n !== document.activeElement) { try { n.focus({ preventScroll: true }); } catch (e) { n.focus(); } }
      }
    });
  }

  /* ---------------------------------------------------------------- door pin */

  var PIN_MAPS_TIMEOUT_MS = 15000;
  var mapsPromise = null;

  function pinEnabled(m) {
    return !!(S.mapsKey && m && m.method === 'delivery' && m.metro);
  }

  function fmtPoint(p) { return p.lat.toFixed(6) + ', ' + p.lng.toFixed(6); }

  function renderPin(v, m) {
    var on = pinEnabled(m);
    show(v.refs.pin, on);
    if (!on) return setRegion(v, 'pin', '');
    var html = m.pin
      ? '<div class="uqs-pin-saved">' +
          '<p class="uqs-msg uqs-msg--ok"><span class="uqs-okdot" aria-hidden="true">' + ICONS.check + '</span>Pin saved</p>' +
          '<span class="uqs-pin-btns">' +
            '<button type="button" class="uqs-linkbtn" data-uqs-action="pin-open" aria-label="Edit your door pin">Edit</button>' +
            '<button type="button" class="uqs-linkbtn" data-uqs-action="pin-remove" aria-label="Remove your door pin">Remove</button>' +
          '</span>' +
        '</div>'
      : '<button type="button" class="uqs-btn uqs-btn--ghost uqs-pin-open" data-uqs-action="pin-open">' +
          '<span class="uqs-pin-ico" aria-hidden="true">' + ICONS.pin + '</span>Pin your exact door <span class="uqs-opt">(optional)</span></button>';
    setRegion(v, 'pin', html);
  }

  function setPin(p) {
    S.pin = p ? E.toPoint(p) : null;
    recompute('pin');
  }

  function removePin(v) {
    setPin(null);
    announce('Door pin removed.');
    var b = v && v.el.querySelector('[data-uqs-action="pin-open"]');
    if (b) { try { b.focus({ preventScroll: true }); } catch (e) { b.focus(); } }
  }

  /** Google Maps JS, loaded once and only when the pin dialog opens. Reuses a tag the theme already added. */
  function loadMaps() {
    var ready = function () { return !!(window.google && window.google.maps && window.google.maps.importLibrary); };
    if (ready()) return Promise.resolve(window.google.maps);
    if (mapsPromise) return mapsPromise;
    mapsPromise = new Promise(function (resolve, reject) {
      var done = false;
      var finish = function (ok) {
        if (done) return;
        done = true;
        clearInterval(poll);
        clearTimeout(timer);
        if (ok) resolve(window.google.maps);
        else { mapsPromise = null; reject(new Error('Google Maps did not load')); }
      };
      var poll = setInterval(function () { if (ready()) finish(true); }, 200);
      var timer = setTimeout(function () { finish(ready()); }, PIN_MAPS_TIMEOUT_MS);
      if (!document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]')) {
        window.__uqsMapsReady = function () { finish(true); };
        var s = document.createElement('script');
        s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(S.mapsKey) +
          '&v=weekly&libraries=places&loading=async&callback=__uqsMapsReady';
        s.async = true;
        s.onerror = function () { finish(false); };
        document.head.appendChild(s);
      }
    });
    return mapsPromise;
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';

  function closePinDialog(restoreFocus) {
    var d = S.pinDialog;
    if (!d) return;
    S.pinDialog = null;
    document.documentElement.classList.remove('uqs-pin-lock');
    try { if (d.el.open && typeof d.el.close === 'function') d.el.close(); } catch (e) { /* not modal */ }
    if (d.el.parentNode) d.el.parentNode.removeChild(d.el);
    if (restoreFocus === false) return;
    var target = d.opener && d.opener.isConnected ? d.opener : null;
    if (!target && d.view) target = d.view.el.querySelector('[data-uqs-action="pin-open"]');
    if (target) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
  }

  function openPinDialog(v, opener) {
    if (S.pinDialog || !pinEnabled(S.model)) return;
    var m = S.model;
    var id = 'uqs-pin' + (++uid);
    var start = m.pin || E.metroCenter(S.config, m.metro);
    var dlg = document.createElement('dialog');
    dlg.className = 'uqs uqs-pin-dialog';
    dlg.setAttribute('aria-labelledby', id + '-title');
    dlg.setAttribute('aria-describedby', id + '-help');
    dlg.innerHTML =
      '<div class="uqs-pin-box">' +
        '<div class="uqs-pin-head">' +
          '<h2 class="uqs-title" id="' + id + '-title">Pin your exact door</h2>' +
          '<button type="button" class="uqs-pin-x" data-pin="cancel" aria-label="Close">' + ICONS.close + '</button>' +
        '</div>' +
        '<p class="uqs-msg uqs-msg--muted" id="' + id + '-help">Search your address or use your location, then drag the pin to your door. ' +
          'On a keyboard, focus the map and use the arrow keys to move the pin.</p>' +
        '<div class="uqs-pin-search" data-pin="search">' +
          '<label class="uqs-label" for="' + id + '-q">Search an address</label>' +
          '<input class="uqs-pin-q" id="' + id + '-q" type="text" autocomplete="street-address" placeholder="Street address">' +
        '</div>' +
        '<button type="button" class="uqs-btn uqs-btn--ghost uqs-pin-locate" data-pin="locate">' +
          '<span class="uqs-pin-ico" aria-hidden="true">' + ICONS.locate + '</span>Use my location</button>' +
        '<div class="uqs-pin-mapwrap" data-pin="mapwrap" tabindex="0" role="group" aria-label="Map with your door pin. Arrow keys move the pin, hold Shift for bigger steps." aria-describedby="' + id + '-readout">' +
          '<div class="uqs-pin-map" data-pin="map"><p class="uqs-msg uqs-msg--muted uqs-pin-loading">Loading the map...</p></div>' +
        '</div>' +
        '<p class="uqs-pin-readout" id="' + id + '-readout" data-pin="readout" aria-live="polite"></p>' +
        '<p class="uqs-msg uqs-msg--warn uqs-pin-warn" data-pin="warn" role="alert" hidden></p>' +
        '<div class="uqs-pin-actions">' +
          '<button type="button" class="uqs-btn uqs-btn--primary" data-pin="save">Save pin</button>' +
          '<button type="button" class="uqs-btn uqs-btn--ghost" data-pin="cancel">Cancel</button>' +
          (m.pin ? '<button type="button" class="uqs-linkbtn uqs-pin-remove" data-pin="remove">Remove pin</button>' : '') +
        '</div>' +
      '</div>';
    var q = function (k) { return dlg.querySelector('[data-pin="' + k + '"]'); };
    var d = { el: dlg, view: v, opener: opener || null, draft: m.pin ? E.toPoint(m.pin) : null, marker: null, map: null, metro: m.metro };
    S.pinDialog = d;

    function readout() {
      q('readout').textContent = d.draft ? 'Pin set near ' + fmtPoint(d.draft) + '.' : 'Pin not set yet. Move the pin to your door.';
    }
    function warn(text) {
      var w = q('warn');
      w.textContent = text || '';
      w.hidden = !text;
    }
    function moveTo(p, recenter, zoom) {
      var pt = E.toPoint(p);
      if (!pt) return;
      d.draft = pt;
      warn('');
      if (d.marker) d.marker.setPosition(pt);
      if (d.map && recenter) {
        d.map.panTo(pt);
        if (zoom) d.map.setZoom(zoom);
      }
      readout();
    }
    d.moveTo = moveTo;

    function save() {
      if (!d.draft) { warn('Move the pin to your door first, or choose Cancel to skip it.'); return; }
      var chk = E.checkPin(S.config, d.metro, d.draft, S.zip);
      if (!chk.ok) {
        var label = (S.config.metros[d.metro] && S.config.metros[d.metro].label) || d.metro;
        warn('That spot is outside our ' + label + ' delivery area (about ' + Math.round(chk.miles) + ' mi out, we go up to ' +
          chk.maxMiles + ' mi). Move the pin to your door, or skip the pin.');
        return;
      }
      setPin(d.draft);      // re-renders the widget first so focus can land on the new Edit button
      closePinDialog();
      announce('Door pin saved.');
    }

    dlg.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-pin]');
      if (!t || !dlg.contains(t)) return;
      var k = t.getAttribute('data-pin');
      if (k === 'cancel') closePinDialog();
      else if (k === 'save') save();
      else if (k === 'remove') { setPin(null); closePinDialog(); announce('Door pin removed.'); }
      else if (k === 'locate') locate();
    });
    dlg.addEventListener('cancel', function (ev) { ev.preventDefault(); closePinDialog(); });
    dlg.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !ev.defaultPrevented) { ev.preventDefault(); closePinDialog(); return; }
      if (ev.key === 'Tab') {
        var f = Array.prototype.slice.call(dlg.querySelectorAll(FOCUSABLE)).filter(function (n) { return !n.closest('[hidden]'); });
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        var ae = document.activeElement;
        if (ev.shiftKey && (ae === first || !dlg.contains(ae))) { ev.preventDefault(); last.focus(); }
        else if (!ev.shiftKey && (ae === last || !dlg.contains(ae))) { ev.preventDefault(); first.focus(); }
      }
    });
    q('mapwrap').addEventListener('keydown', function (ev) {
      var dir = { ArrowUp: [1, 0], ArrowDown: [-1, 0], ArrowLeft: [0, -1], ArrowRight: [0, 1] }[ev.key];
      if (!dir || ev.altKey || ev.ctrlKey || ev.metaKey) return;
      var t = ev.target;
      if (t && /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
      ev.preventDefault();
      var base = d.draft || (d.marker && E.toPoint(d.marker.getPosition())) || start;
      var meters = ev.shiftKey ? 25 : 4;
      var dLat = meters / 111320;
      var dLng = meters / (111320 * Math.max(0.2, Math.cos(base.lat * Math.PI / 180)));
      moveTo({ lat: base.lat + dir[0] * dLat, lng: base.lng + dir[1] * dLng }, true);
    });

    function locate() {
      if (!navigator.geolocation) { warn('Your browser cannot share your location. Search your address or drag the pin instead.'); return; }
      q('readout').textContent = 'Finding your location...';
      navigator.geolocation.getCurrentPosition(function (pos) {
        if (S.pinDialog !== d) return;
        moveTo({ lat: pos.coords.latitude, lng: pos.coords.longitude }, true, 18);
      }, function () {
        if (S.pinDialog !== d) return;
        readout();
        warn('We could not get your location. Search your address or drag the pin instead.');
      }, { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 });
    }

    document.body.appendChild(dlg);
    document.documentElement.classList.add('uqs-pin-lock');
    if (typeof dlg.showModal === 'function') { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } }
    else dlg.setAttribute('open', '');
    readout();
    var firstFocus = q('search').querySelector('input');
    try { firstFocus.focus({ preventScroll: true }); } catch (e) { firstFocus.focus(); }

    loadMaps().then(function (maps) {
      return Promise.all([maps.importLibrary('maps'), maps.importLibrary('marker'), maps.importLibrary('places')]);
    }).then(function (libs) {
      if (S.pinDialog !== d) return;
      buildMap(d, libs[0], libs[1], libs[2], start, m.pin ? 18 : 12);
    }).catch(function (err) {
      if (S.pinDialog !== d) return;
      if (window.console) console.warn('[uforiq-schedule] map failed', err);
      q('map').innerHTML = '<p class="uqs-msg uqs-msg--error uqs-pin-loading">The map did not load. You can skip the pin and add details in your delivery instructions.</p>';
    });
  }

  function buildMap(d, mapsLib, markerLib, placesLib, start, zoom) {
    var q = function (k) { return d.el.querySelector('[data-pin="' + k + '"]'); };
    var host = q('map');
    host.innerHTML = '';
    var MapCls = mapsLib.Map;
    var MarkerCls = markerLib.Marker || (window.google.maps && window.google.maps.Marker);
    d.map = new MapCls(host, {
      center: start, zoom: zoom, clickableIcons: false, keyboardShortcuts: false, gestureHandling: 'greedy',
      mapTypeControl: false, streetViewControl: false, fullscreenControl: false
    });
    d.marker = new MarkerCls({ map: d.map, position: d.draft || start, draggable: true, title: 'Your door' });
    d.marker.addListener('dragend', function () { d.moveTo(d.marker.getPosition(), false); });
    d.map.addListener('click', function (ev) { if (ev && ev.latLng) d.moveTo(ev.latLng, false); });

    var go = function (loc) { if (loc && S.pinDialog === d) d.moveTo(loc, true, 18); };
    var search = q('search');
    var input = search.querySelector('input');
    if (placesLib.PlaceAutocompleteElement) {
      // Places API (New) widget; the plain input is swapped out for it.
      var pac = new placesLib.PlaceAutocompleteElement({ includedRegionCodes: ['us'] });
      pac.className = 'uqs-pin-pac';
      pac.id = input.id;
      try { pac.setAttribute('aria-label', 'Search an address'); } catch (e) { /* read only */ }
      search.replaceChild(pac, input);
      var pick = function (place) {
        if (!place) return;
        place.fetchFields({ fields: ['location'] }).then(function () { go(place.location); }, function () { /* keep the map */ });
      };
      pac.addEventListener('gmp-select', function (ev) { if (ev.placePrediction) pick(ev.placePrediction.toPlace()); });
      pac.addEventListener('gmp-placeselect', function (ev) { pick(ev.place); });
    } else if (placesLib.Autocomplete) {
      var ac = new placesLib.Autocomplete(input, { componentRestrictions: { country: 'us' }, fields: ['geometry'], types: ['address'] });
      ac.addListener('place_changed', function () {
        var pl = ac.getPlace();
        go(pl && pl.geometry && pl.geometry.location);
      });
    }
  }

  /* ---------------------------------------------------------------- lifecycle */

  function restoreFromCart() {
    var a = (S.cart && S.cart.attributes) || {};
    var saved = store.read();
    var method = a[ATTR.method];
    if (method === 'delivery' || method === 'shipping') { S.method = method; S.methodExplicit = true; }
    else if (saved.method === 'delivery' || saved.method === 'shipping') { S.method = saved.method; S.methodExplicit = true; }
    S.selection = {
      slotId: a[ATTR.slotId] || null,
      priority: a[ATTR.priority] === 'yes',
      dayKey: null
    };
    S.saveNote = ls.get(SAVE_KEY) !== '0';
    S.pin = E.parsePin(a[ATTR.pin]);
    var pre = prefillNote(saved);
    S.note = a[ATTR.note] || pre;
    S.notePrefilled = !!S.note && S.note === pre;
    S.zip = saved.zip && E.normalizeZip(saved.zip) ? saved.zip : '';
  }

  /**
   * Saved instructions for a cart that has no Delivery-Note yet: the logged-in
   * customer's account value first, then this browser's copy. Skipped when the
   * shopper turned saving off, or already edited (or cleared) this cart's note.
   */
  function prefillNote(saved) {
    if (!S.saveNote) return '';
    if (S.cart && S.cart.token && saved.noteCart === S.cart.token) return '';
    var src = S.customerNote ? S.customerNote : (ls.get(NOTE_KEY) || '');
    return E.cleanNote(src);
  }

  function init(el) {
    if (S.initPromise) return S.initPromise;
    S.config = loadConfig(el);
    if (!S.config) {
      if (window.console) console.error('[uforiq-schedule] no config found in the snippet');
      S.initPromise = Promise.resolve();
      return S.initPromise;
    }
    var inlineCart = readCartAttr(el);
    var cartP = inlineCart && inlineCart.items ? Promise.resolve(inlineCart) : fetchCart();
    S.initPromise = cartP.then(function (cart) {
      S.cart = cart;
      S.area = readArea();
      restoreFromCart();
      S.started = true;
      recompute('init');
      return (S.zip ? resolveCurrentZip() : Promise.resolve());
    }).then(function () {
      S.ready = true;
      recompute('restore');
    }, function (err) {
      if (window.console) console.error('[uforiq-schedule] init failed', err);
      S.cart = S.cart || { items: [], attributes: {}, total_price: 0 };
      S.started = true;
      S.ready = true;
      recompute('init');
    });
    return S.initPromise;
  }

  var globalsBound = false;
  function bindGlobals() {
    if (globalsBound) return;
    globalsBound = true;
    installGate();
    window.addEventListener('uforiq:location:changed', function (ev) {
      onLocationChanged(ev && ev.detail ? ev.detail.location : readArea());
    });
    setInterval(function () { revalidate('tick'); }, opts.revalidateMs);
    var onFocus = function () {
      if (!S.started) return;
      fetchCart().then(function () { revalidate('tick'); }, function () { revalidate('tick'); });
    };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') onFocus(); });
  }

  /** Mount (or re-mount) the widget into a [data-uqs-root] element. Idempotent. */
  function mount(el, options) {
    if (!el) return null;
    var context = (options && options.context) || el.getAttribute('data-context') || 'cart';
    bindGlobals();
    var existing = liveViews().filter(function (v) { return v.el === el; })[0];
    if (existing && el.querySelector('.uqs-inner')) {
      renderView(existing);
      return api;
    }
    if (existing) views.splice(views.indexOf(existing), 1);
    var v = createView(el, context);
    views.push(v);
    if (S.initPromise && S.started && !hasPendingWrite()) {
      // A re-rendered drawer carries a fresh server-side copy of the cart.
      var fresh = readCartAttr(el);
      if (fresh && fresh.items) { S.cart = fresh; recompute('refresh'); }
    }
    init(el).then(function () { renderView(v); });
    if (S.model) renderView(v);
    return api;
  }

  function refresh(cartJson) {
    var p = cartJson && cartJson.items ? Promise.resolve(cartJson) : fetchCart();
    return p.then(function (cart) {
      S.cart = cart;
      if (!(window.UforiqLocation && window.UforiqLocation.get)) {
        var a = readArea();
        if (a !== S.area) return onLocationChanged(a);
      }
      recompute('refresh');
      return publicState();
    });
  }

  function autoMount() {
    Array.prototype.slice.call(document.querySelectorAll('[data-uqs-root]')).forEach(function (el) {
      if (!el.querySelector('.uqs-inner')) mount(el);
    });
  }

  var api = {
    version: VERSION,
    mount: mount,
    isComplete: isComplete,
    getState: publicState,
    refresh: refresh,
    /** Call before any custom JS navigation to checkout; true = OK to go. */
    guardCheckout: function () {
      if (isComplete() && !pendingForCheckout()) return true;
      if (isComplete()) { flush(); return false; }
      showBlocked(null);
      return false;
    },
    flush: flush,
    /** Preview/test hook: pin "now" to an epoch ms (or a function), null for the real clock. */
    setNow: function (ms) { S.nowOverride = ms; revalidate('tick'); },
    ready: function () { return S.initPromise || Promise.resolve(); },
    engine: E
  };
  window.UforiqSchedule = api;

  if (opts.autoMount) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoMount);
    else autoMount();
    if (typeof MutationObserver === 'function') {
      var moTimer = null;
      var mo = new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var r = records[i];
          // new nodes, or another script clearing aria-disabled on a checkout button we block
          if ((r.addedNodes && r.addedNodes.length) ||
              (r.type === 'attributes' && r.target.hasAttribute && r.target.hasAttribute('data-uqs-blocked'))) {
            if (!moTimer) moTimer = setTimeout(function () { moTimer = null; autoMount(); syncCheckoutButtons(); }, 0);
            return;
          }
        }
      });
      var startObserving = function () {
        mo.observe(document.body || document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-disabled', 'class'] });
      };
      if (document.body) startObserving(); else document.addEventListener('DOMContentLoaded', startObserving);
    }
  }

})();
